import React from "react";

// Use this link to upload the img https://portal.azure.com/#view/Microsoft_Azure_Storage/ContainerMenuBlade/~/overview/storageAccountId/%2Fsubscriptions%2F1efe367c-ebe4-442f-9bc4-a3a1adf1eed1%2FresourceGroups%2Ftechpos_dev%2Fproviders%2FMicrosoft.Storage%2FstorageAccounts%2Ftechposdev/path/newfeatureimages/etag/%220x8D9F1B112DD7972%22/defaultEncryptionScope/%24account-encryption-key/denyEncryptionScopeOverride~/false/defaultId//publicAccessVal/Blob

export const listNewFeatures = [
    {
        title: "Surfside Integration",
        dateAdded: "05/30/2025",
        contents: (<div>
            <h3>Surfside has been integrated to the system.</h3>
            <ul>
                <p>Surfside is a system that allows you to earn money by displaying banner ads on your web and TV menus. Your earnings are based on how many people view or click the ads. Please contact TechPOS to enable Surfside banners.</p>
                <br />
                <p><b>Web: </b></p>
                <p>After confirming with the TechPOS team that your Surfside banner is enabled, go to Web Menu &gt; UI Settings. Then, find ‘Banner Settings’ and set the banner display mode to ‘Surf’.</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/Surfside1.png" className="imgNewFeatureComponent mt-1" style={{border: '2px solid gray'}} />
                <p>E-commerce users will see the banners across all pages - Homepage, Menu, Product, Cart, and Checkout.</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/Surfside2.png" className="imgNewFeatureComponent mt-1" style={{border: '2px solid gray'}} />
                <p>Once customers click the banner, they will be directed to the menu page with the brand filter applied.</p>
                <br />
                <br />
                <p><b>TV Screens: </b></p>
                <p>Please contact TechPOS support to enable banner ads on your TV screens.</p>
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "AgGrid Implementation in Hourly Sales Report",
        dateAdded: "05/30/2025",
        contents: (<div>
            <h3>Hourly Sales Averaged Reports with AgGrid</h3>
            <br />
            <ul>
                <p><b>Navigation Steps:</b></p>
                <p>Go to Menu &gt; Report &gt; Hourly Sales Averaged Report</p>
                <br />
                <br />
                <p><b>Select the Date Range and Branch, and click “VIEW REPORT”</b></p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/AgGridReport.png" className="imgNewFeatureComponent mt-1" style={{border: '2px solid gray'}}  />
                <br />
                <br />
                <p><b>Searching and Filtering</b></p>
                <p>
                    Users can easily filter data in any column by clicking the filter icon:
                </p>
                <ul style={{lineHeight: 1.8}}>
                    <li>Text Columns (e.g., Name, Email): Type to search for exact or partial matches.</li>
                    <li>Date Columns: Choose a specific date or date range.</li>
                    <li>Dropdown Filters: Select one or more values from a list.</li>
                    <i>Tip: Multiple filters can be active at the same time. </i>
                </ul>
                <br />
                <br />
                <p><b>Filtering with the Mini Filter</b></p>
                <p>
                    When you click the filter icon (🔽) in a column header, you'll see a Mini Filter field at the top of the dropdown.
                </p>
                <p>How to use it:</p>
                <ul style={{lineHeight: 1.8}}>
                    <li>Start typing in the Mini Filter box to narrow down the filter options below.</li>
                    <li>As you type, the list will instantly update to show only matching values.</li>
                    <li>Check or uncheck boxes to filter the column data.</li>
                </ul>
                <br />
                <br />
                <p><b>Sorting</b></p>
                <p>
                    To sort data, click the column header:<br />
                </p>
                <ul style={{lineHeight: 1.8}}>
                    <li>1st click = Sort ascending 🔼</li>
                    <li>2nd click = Sort descending 🔽</li>
                    <li>3rd click = Remove sorting</li>
                    <i>Users can sort multiple columns by holding Shift while clicking another header.</i>
                </ul>
                <br />
                <br />
                <p><b>Moving and Resizing Columns</b></p>
                <ul style={{lineHeight: 1.8}}>
                    <li>Resize: Drag the edge of a column header to make it wider or narrower.</li>
                    <li>Reorder: Click and drag a column header to change its position.</li>
                </ul>
                <br />
                <br />
                <p><b>Exporting to CSV</b></p>
                <p>To download the current view of the grid:</p>
                <ol style={{lineHeight: 1.8}}>
                    <li>Click the Export CSV button (if enabled). </li>
                    <li>The file will automatically download with your filtered and sorted data. </li>
                </ol>
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Bank Deposit Update and Report",
        dateAdded: "05/30/2025",
        contents: (<div>
            <h3>Bank deposit has been updated and new report has been added.</h3>
            <ul>
                <p>Bank Deposit Report is in the Admin Page as follows:</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/BankDeposit1.png" className="imgNewFeatureComponent mt-1" style={{border: '2px solid gray'}} />
                <br />
                <br />
                <p><b>Search (Filter) feilds are as follows:</b></p>
                <ul style={{lineHeight: 1.8}}>
                    <li>Start Date</li>
                    <li>End Date</li>
                    <li>Deposit Date</li>
                    <li>Amount $</li>
                    <li>Reference Code</li>
                    <li>Branch Selection (The default Branch is the current branch, the customer also can select multiple branches or all Branches)</li>
                </ul>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/BankDeposit2.png" className="imgNewFeatureComponent mt-1" style={{border: '2px solid gray'}} />
                <br />
                <br />
                <p><b>Bank deposit columns are as follows:</b></p>
                <ul style={{lineHeight: 1.8}}>
                    <li>Branch ID</li>
                    <li>Branch Name</li>
                    <li>Employee ID</li>
                    <li>Employee First Name</li>
                    <li>Employee Last Name</li>
                    <li>Deposit Date</li>
                    <li>Created Date</li>
                    <li>Modified Date</li>
                    <li>Amount $</li>
                    <li>CashSales</li>
                    <li>CashVariance = Amount - CashSales</li>
                    <li>Coin Order $</li>
                    <li>Tips $ ( TIPS are hidden for HIGHTIDE customer)</li>
                    <li>Reference Code</li>
                    <li>Reference Notes</li>
                </ul>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/BankDeposit3.png" className="imgNewFeatureComponent mt-1" style={{border: '2px solid gray'}}/>
                <br />
                <br />
                <p><b>Reports are in two types:</b></p>
                <ul style={{lineHeight: 1.8}}>
                    <li>UI View</li>
                    <li>Downlowd report in CSV file</li>
                </ul>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/BankDeposit4.png" className="imgNewFeatureComponent mt-1" style={{border: '2px solid gray'}} />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/BankDeposit5.png" className="imgNewFeatureComponent mt-1" style={{border: '2px solid gray'}} />
                <br />
                <br />
                <p><b>Add/Edit Bank Deposit</b></p>
                <p>
                    Each customer can add or edit several bank deposits a day.
                </p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/BankDeposit6.png" className="imgNewFeatureComponent mt-1" style={{border: '2px solid gray'}} />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Product Auto Tag",
        dateAdded: "05/30/2025",
        contents: (<div>
            <h3>Product Auto Tag Printing has been added</h3>
            <ul>
                <p>This guide will help you generate and print product tags easily and quickly. Follow the steps below to create your tags in just a few clicks.</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/PAT1.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p><b>Select Your Branch</b></p>
                <p>
                    Go to the Store and Product Status Setup <br />
                    Click the dropdown menu and choose the branch where the product will be sold <br />
                    Select In Stock to retrieve product that are in stock <br />
                    <i>Selecting the correct branch ensures the tags reflect the right pricing, branding, or local details.</i>
                </p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/PAT2.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p><b>Choose Your Product SKU(s)</b></p>
                <p>
                    In the SKU Selection field, search or browse to find the product(s) you want to print tags for. <br />
                    You can use the drop down option to select specific category each time. <br />
                    You can select one SKU at a time or multiple, depending on your needs. <br />
                    <i>If you don’t know the SKU, try searching by product name.</i>
                </p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/PAT3.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p><b>Pick a Tag Template</b></p>
                <p>
                    Go to the Template Selection area. <br />
                    Choose the tag design that best suits your product type or display preference. <br />
                    Templates may vary by size, layout, or branding. <br />
                </p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/PAT4.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p><b>Generate the PDF</b></p>
                <p>
                    Once you’ve chosen the branch, SKU(s), and template, click the 'Generate PDF' button. <br />
                    The system will process your selection and create a PDF file with your product tags. <br />
                </p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/PAT5.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p><b>Print</b></p>
                <p>
                    When the PDF is ready, open the PDF file and print it using your tag printer or a standard printer with tag sheets.
                </p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/PAT6.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Digital Signage (DS)",
        dateAdded: "05/30/2025",
        contents: (<div>
            <h3>Digital Signage has been added</h3>
            <br />
            <ul>
                <p>Digital signage display products of your choice from a specific category based on your inventory quantity.  We offer multiple themes,  both horizontal and vertical orientations.</p>
                <br />
                <br />
                <p><b>1. Display Multiple Categories at Once</b></p>
                <p>
                    You can now select more than one product category to show on a single screen. This allows for a richer, more varied menu display and lets you promote multiple product groups at the same time.
                </p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/DigitalSignage1.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p><b>2. Filter Products by Species</b></p>
                <p>Fine-tune your menu by filtering products based on their species (for example, Indica, Sativa, Hybrid — if applicable). This ensures your customers see only relevant products.</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/DigitalSignage2.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p><b>3. New Themes Available</b></p>
                <p>We have added new screen themes so you can match your signage to your branding, season, or store vibe. Try them out for a fresh, eye-catching look!</p>
                <p>
                    <img src="https://techposdev.blob.core.windows.net/newfeatureimages/DigitalSignage3.png" className="imgNewFeatureComponent mt-1" />
                </p>
                <p>
                    <img src="https://techposdev.blob.core.windows.net/newfeatureimages/DigitalSignage4.png" className="imgNewFeatureInlineComponent mt-1" />
                    <img src="https://techposdev.blob.core.windows.net/newfeatureimages/DigitalSignage5.png" className="imgNewFeatureInlineComponent mt-1" />
                </p>
                <br />
                <br />
                <p><b>4. Highlight Product Characteristics: Mood & Events</b></p>
                <p>
                    You can now display extra details for each product, such as: <br />
                    - Mood: (e.g., Relaxing, Uplifting)  <br />
                    - Events: (e.g., Daily Special, Weekend Feature) <br />
                    These details help your customers make informed choices right from the screen. <br />
                </p>
                <br />
                <br />
                <p><b>5. Support for Ads — Earn Passive Revenue</b></p>
                <p>
                    Turn your screens into an additional revenue stream! <br />
                    You can now: <br />
                    - Display third-party or in-house ads alongside your product menu.  <br />
                    - Earn passive income while promoting your own deals or trusted partners.  <br />
                </p>
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Global Payment Integration",
        dateAdded: "05/30/2025",
        contents: (<div>
            <h3>Global Payment has been implemented to the system as a new payment option.</h3>
        </div>)
    },
    {
        title: "First Nation Tax Popup",
        dateAdded: "05/30/2025",
        contents: (<div>
            <h3>This popup enables you to add the First Nation discount into the order.</h3>
            <ul>
                <p>Navigation Steps: Go to Menu &gt; POS Sales &gt; Options button &gt; Add / Remove FN Tax</p>
                <p>Click on the “Search Member” button to begin.</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/FNTaxStep1.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>Type the member's First Name or Member Number in the search bar, and Select the correct member from the list, then click “START ORDER.”</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/FNTaxStep2.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>Click the “Options” button and choose “Add / Remove FN Tax.”. (Note: The “Add / Remove FN Tax” option is only enabled if a member is selected.)</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/FNTaxStep3.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>A pop-up window will appear showing the member’s FN ID status.</p>
                <p>Staff must: 1. Select Identification Type as "Status ID"; 2. Physically verify the ID number from the customer's card.</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/FNTaxStep4.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>Click “Confirm” to apply the FN tax to the order.</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/FNTaxStep5.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>If needed, go back to the “Options” menu and click “Add / Remove FN Tax” again to remove it.</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/FNTaxStep5.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Campaign Mix and Match",
        dateAdded: "05/30/2025",
        contents: (<div>
            <h3>Campaign Mix and Match has been added.</h3>
            <ul>
                <p>A new mix and match toggle has been added.</p>
                <p>Toggle on "Allow Mix-And-Match"</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/CampaignMixAndMatch1.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>There will be a new table at the bottom to set Mix and Match rules, and you can add rules by clicking the add button and delete by clicking the trash can button.</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/CampaignMixAndMatch2.png" className="imgNewFeatureComponent mt-1" />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/CampaignMixAndMatch3.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>With Mix and match On, when you click Add Items to Campaign, it will allow you to add BOTH campaigns and products to this campaign (without this setting and with ApplyPriceByQuantity OFF, you can only add EITHER campaigns OR products)</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/CampaignMixAndMatch4.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>It will look like this if you add both categories or products</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/CampaignMixAndMatch5.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>
                    You only need to add at least 1 product or category. Its not necessary to add both product or category. <br />
                    However, there must be at least 1 row in Mix and Match rules. <br />
                    If there are not enough products or mix and match rules, it should show error when you try to save:
                </p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/CampaignMixAndMatch6.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>If mix and match rules are not filled in, it will have error:</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/CampaignMixAndMatch7.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Customized User Roles",
        dateAdded: "04/30/2025",
        contents: (<div>
            <h3>Customized User Roles has been added.</h3>
            <ul>
                <p>Navigation Steps: Go to Dashboard &gt; Users  &gt; User Role &gt;</p>
                <p>Note: only Executive Role has access to create Customized User Roles</p>
                <br />
                <br />
                <p>From the User Role selection, you will see a list of pre created standard User Roles that can be modified but not removed. These standard roles have been internally created with internal settings that cannot be modified.</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/CustomizedUserRole1.webp" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p><b>To create a new role:</b></p>
                <p>Step 1: Click + Add New Role</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/CustomizedUserRole2.webp" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>Step 2: Enter the desired Role Name in the input field provided and click Save Role</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/CustomizedUserRole3.webp" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>Step 3: Click here then choose Edit to access additional options and permissions for this user role</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/CustomizedUserRole4.webp" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>Step 4: Select Permissions for this user role as needed</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/CustomizedUserRole5.webp" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>Step 5: Select Report access for this user role. Select ALL reports or choose individual reports then click Save Report Access to save your changes</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/CustomizedUserRole6.webp" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>
                    Step 6: Select the Page(s) access for this user role and click Save Page Access to save your changes. <br />
                    <i>Note: If this user role will have access to any reports, please ensure that Reports is selected from the Pages menu</i>
                </p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/CustomizedUserRole7.webp" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>Step 7: Click Save Role to confirm and apply changes to the User Role settings</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/CustomizedUserRole8.webp" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p><b>Assigning an Employee to new User Role</b></p>
                <p>Step 1: From the Dashboard select Users '&gt;' Employee</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/CustomizedUserRole9.webp" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>Step 2: Click here to add a new Employee to the system</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/CustomizedUserRole10.webp" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>Step 3: Enter the required details to create the new Employee then click the Role dropdown to select the appropriate user role for this employee</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/CustomizedUserRole11.webp" className="imgNewFeatureComponent mt-1" />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/CustomizedUserRole12.webp" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>Step 4: Select all necessary branches that this employee will have access to, if there are no additional branches, the current branch will be selected as default. Enter a password and confirm for this user. Click Save to save Employee changes.</p>
                <br />
                <br />
                <p><i>Note: An automated email will be sent to the new employee and passwords can be changed by the user after login.</i></p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/CustomizedUserRole13.webp" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Inventory Audit",
        dateAdded: "04/30/2025",
        contents: (<div>
            <h3>Inventory Audit Page has been added.</h3>
            <br />
            <br />
            <ul>
                <p style={{fontSize: 24}}><b>Inventory Audit Page</b></p>
                <p><a href="https://youtu.be/IZq7KrkLoHU" style={{fontSize: 18}}>Click Here for Tutorial Video</a></p>
                <p>This page provides you with the tools to carry out inventory audits, keeping your stock up-to-date and accurately recorded in the system.</p>
                <p>Navigation Steps: Go to Menu &gt; Inventory &gt; Inventory Audit</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/InventoryAudit1.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p style={{fontSize: 24}}><b>Create Inventory Audit</b></p>
                <p>Step 1: Click on Add New Audit Button</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/InventoryAudit2.png" className="imgNewFeatureComponent mt-1" />
                <p>Step 2: Enter the Audit Name, and choose if you prefer to lock expected quantity, then click Confirm. </p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/InventoryAudit3.png" className="imgNewFeatureComponent mt-1" />
                <p class="pNoteSection">
                    <b>Note:</b> Locking the Expected Quantity ensures that the expected quantity won't automatically adjust, even if a product is sold during the audit. This means if there are sales happening on the floor, the expected quantity will not change as long as the counted quantity is entered. For products without the expected quantity entered, it will continue adjusting based on sales.
                </p>
                <p>Step 3: Add products to the audit. There are multiple ways to add products to the audit: </p>
                <p class="pNoteSection">
                    <b>Keep in mind:</b> When utilizing the import functions below (Category, Brand, Uncounted Products), the system will only import products that are in stock. Here are two situations concerning out of stock products:
                    <ul style={{lineHeight: 1.6}}>
                        <li> If the quantity in the Warehouse is out of stock (0 units), it won't appear on the import list.</li>
                        <li> If the product isn't in the Warehouse, it indicates there's no prior history or record of a Purchase Order. In this case, a new Purchase Order must be initiated.</li>
                    </ul>
                </p>
                <p style={{indent: "60px"}}>
                    <ul>
                        <li>
                            <p style={{fontSize: "17px"}}>Option 1: Add by Category</p>
                            <p style={{fontSize: "16px"}}>You can import using the Main Category, Sub-Category, or Sub-Sub-Category. Sub-Category will be filtered based on the Main Category, and Sub-Sub-Category will be filtered based on the Sub-Category.</p>
                            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/InventoryAudit4.png" className="imgNewFeatureComponent mt-0" />
                        </li>
                        <br />
                        <li>
                            <p style={{fontSize: "17px"}}>Option 2: Add by Brand</p>
                            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/InventoryAudit5.png" className="imgNewFeatureComponent mt-0" />
                        </li>
                        <br />
                        <li>
                            <p style={{fontSize: "17px"}}>Option 3: Add by Name/SKU Number</p>
                            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/InventoryAudit6.png" className="imgNewFeatureComponent mt-0" />
                        </li>
                        <br />
                        <li>
                            <p style={{fontSize: "17px"}}>Option 4: Add by Uncounted Products</p>
                            <p style={{fontSize: "16px"}}>This feature allows you to choose a specific date. After selecting the date, you'll be able to choose a category for products that haven't been counted yet. Finally, it'll show you how many products in that category are still uncounted.</p>
                            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/InventoryAudit7.png" className="imgNewFeatureComponent mt-0" />
                        </li>
                    </ul>
                </p>
                <br />
                <br />
                <p style={{fontSize: 24}}><b>Entering Counted Quantity & Posting it for Review (Store Level)</b></p>
                <p>Step 1: After adding products to the audit, a field will appear for entering the Counted Quantity.</p>
                <br />
                <p>Step 2: You can find products in the audit either by searching manually or by scanning their barcodes.</p>
                <br />
                <p>Step 3: Input the counted quantity.</p>
                <p class="pNoteSection">
                    <b>Store Level View:</b> Please perform a blind count at the store level and input the counted quantity. For the store level view, please note that the expected quantity, adjust button, difference quantity, and difference cost will be hidden. (Jun 20 updated, Changed to AgGrid)
                </p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/InventoryAudit8.png" className="imgNewFeatureComponent mt-0" />
                <br />
                <p>Step 4: Once you've finished the count, hit the Verify button at the top for the management team to review your audit.</p>
                <br />
                <p>Step 5: Once verified, status will now change. Click on Edit button if any changes needed. </p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/InventoryAudit9.png" className="imgNewFeatureComponent mt-0" />
                <br />
                <br />
                <p style={{fontSize: 24}}><b>Verifying the Audit and Submitting for Review (Management Level)</b></p>
                <p>Step 1: Go to click on Verify Button. Audit can only be verified if the status is set to “Verify”. </p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/InventoryAudit10.png" className="imgNewFeatureComponent mt-0" />
                <br />
                <p>Step 2: Review the discrepancies. </p>
                <p class="pNoteSection">
                    <b>Management Team View:</b> Should there be a discrepancy between the counted and expected quantities, an adjustment button, Difference Quantity, and Difference Cost will show up.
                </p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/InventoryAudit11.png" className="imgNewFeatureComponent mt-0" />
                <br />
                <p>Step 3: Review which products are eligible for recount, or use the 'select all' option to include all products with discrepancies. </p>
                <br />
                <p>Step 4: After your review, please select 'Recount' button to forward it to the store for further verification. </p>
                <br />
                <br />
                <p style={{fontSize: 24}}><b>Audit Recount (Store Level)</b></p>
                <p>Step 1: At the store level, the status will now transition to 'Recount'.</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/InventoryAudit12.png" className="imgNewFeatureComponent mt-0" />
                <br />
                <p>Step 2: The system will now display items that are prepared for recounting. The store level can input the recounted quantity in the "New Quantity" field.</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/InventoryAudit13.png" className="imgNewFeatureComponent mt-0" />
                <br />
                <p>Step 3: Click on Verify to post the recounted quantity. </p>
                <br />
                <br />
                <p style={{fontSize: 24}}><b>Adjusting Inventory Quantity (Management Level)</b></p>
                <p>Step 1: To adjust inventory, click on Adjust Button. </p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/InventoryAudit14.png" className="imgNewFeatureComponent mt-0" />
                <br />
                <p>Step 2: Choose the warehouse and lot number that need adjustment.</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/InventoryAudit15.png" className="imgNewFeatureComponent mt-0" />
                <br />
                <p>Step 3: Enter the actual quantity for the specified lot and warehouse. </p>
                <br />
                <p>Step 4:The Adjustment Reason code needs to be selected based on the quantity entered. Extra notes can be entered too for tracking. </p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/InventoryAudit16.png" className="imgNewFeatureComponent mt-0" />
                <p class="pNoteSection">
                    <b>Note:</b> Adjustments and reason codes will be monitored and will seamlessly appear in compliance reports.
                </p>
                <br />
                <p>Step 5: The verification and recounting process will continue until it is fully completed and finalized. Click on Complete button once finalized. </p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/InventoryAudit17.png" className="imgNewFeatureComponent mt-0" />
                <br />
                <p style={{fontSize: 24}}><b>Managing Inventory Audits</b></p>
                <p>You can view, edit, delete, and download audits. Completed audits are viewable, pending audits are editable, and all audits can be downloaded in csv format. </p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/InventoryAudit18.png" className="imgNewFeatureComponent mt-0" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Sample Direct",
        dateAdded: "03/20/2024",
        contents: (<div>
            <h3>Sample direct has been added.</h3>
            <ul>
                <p>Use the Order Sample tab to order samples.</p>
                <p>Click "Add to Cart" to add items to cart, or click on individual products to view details and add to cart.</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/sampledirect1.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>When you click on View Cart, you can enter your information.</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/sampledirect2.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>Click "Submit Request" at the bottom to submit your order.</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/sampledirect3.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>Use the Upcoming Drops tab to view products soon to be entering the market. Click on "I'm Interested" to subscribe to information about the product.</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/sampledirect4.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>Enter your contact information then click "Get Notified" to get notified of news.</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/sampledirect5.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Integration Dashboard",
        dateAdded: "02/02/2024",
        contents: (<div>
            <h3>A new Integration Dashboard has been added.</h3>
            <ul>
                <p>Use the search field and Type filter to find the integration you are interested in. Contact our customer support to activate or deactivate integrations.</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/integrationdashboard.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "CSV download for MultiStore Management",
        dateAdded: "02/02/2024",
        contents: (<div>
            <h3>The ability to download csv on the Multistore Management page has been added.</h3>
            <ul>
                <p>You can download from the main page.</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/multistorecsv1.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>You can also download for individual products.</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/multistorecsv2.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Inventory Log Report",
        dateAdded: "01/24/2024",
        contents: (<div>
            <h3>The new Inventory Log report has been added.</h3>
            <ul>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/inventorylog.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Lock Expected Quantity in Inventory Audit",
        dateAdded: "01/04/2024",
        contents: (<div>
            <h3>Please note that it is not recommended to use this feature. You accept the risk of your audit and actual inventory not matching if you use this feature.</h3>
          <ul>
            <p>The ability to lock Expected Quantity in Inventory Audit has been added.</p>
            <p>Use the toggle to turn on this setting when creating a new audit. This setting applies to each audit individually.</p>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/auditlock1.png" className="imgNewFeatureComponent mt-1" />
            <br />
            <br />
            <p>In the audit, add products for audit as usual.</p>
            <p>While you have not entered a value in Counted Quantity, the Expected Quantity of that product will reflect current warehouse quantity in the system, and will change if there are any changes in the warehouse.</p>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/auditlock2.png" className="imgNewFeatureComponent mt-1" />
            <br />
            <br />
            <p>Once you enter a value in Counted Quantity, the Expected Quantity for that product is now locked. It will not change even if the actual warehouse quantity changes due to movements or sales.</p>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/auditlock3.png" className="imgNewFeatureComponent mt-1" />
            <br />
            <br />
            <p>If your entered Counted Quantity does not match the Expected Quantity, the adjust button will appear.</p>
            <p>The Counted Quantity must match the Expected Quantity in order for you to complete the audit. You must either adjust the Counted Quantity or the Expected Quantity.</p>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/auditlock4.png" className="imgNewFeatureComponent mt-1" />
            <br />
            <br />
            <p>Clicking on the Adjust button will open the Inventory Adjustment dialog, which is the same adjustment dialog when audit lock setting is not on.</p>
            <p>However, a new field for changing the Expected Quantity has been added. This will adjust the Expected Quantity in this audit, but will not change the quantity in the actual warehouse.</p>
            <p>(Optional) To change the quantity in the warehouse, use the table above the Expected Quantity field to adjust. Doing this will NOT change Expected Quantity when audit lock is on.</p>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/auditlock5.png" className="imgNewFeatureComponent mt-1" />
            <br />
            <br />
            <p>Once you click Confirm, the Expected Quantity will be changed.</p>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/auditlock6.png" className="imgNewFeatureComponent mt-1" />
            <br />
            <br />
          </ul>
        </div>)
    },
    {
        title: "Add / Remove Reward Points in POS",
        dateAdded: "12/06/2023",
        contents: (<div>
          <ul>
            <p>The ability to add or remove reward points in the POS has been added.</p>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/rewardpointpos1.png" className="imgNewFeatureComponent mt-1" />
            <br />
            <br />
            <p>Clicking on "Reward Points" will open dialog to adjust reward points, similar to adjusting in members page. Manager approval is needed to adjust directly in the POS.</p>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/rewardpointpos2.png" className="imgNewFeatureComponent mt-1" />
            <br />
            <br />
          </ul>
        </div>)
    },
    {
        title: "Daily Inventory Snapshot Report Filters",
        dateAdded: "12/05/2023",
        contents: (<div>
          <ul>
            <p>A new field to filter the report by warehouse type has been added.</p>
            <br/>
            <br/>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/dailyinventorysnapshotwarehouse.png" className="imgNewFeatureComponent mt-1" /><br />
            <br />
          </ul>
        </div>)
    },
    {
        title: "Store Rules Delete Button",
        dateAdded: "12/05/2023",
        contents: (<div>
          <ul>
            <p>The ability to delete store rules have been added.</p>
            <br/>
            <br/>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/storerulesdelete.png" className="imgNewFeatureComponent mt-1" /><br />
            <br />
          </ul>
        </div>)
    },
    {
        title: "Cash Register Enhancements",
        dateAdded: "11/28/2023",
        contents: (<div>
          <ul>
            <p>The Cash Register view has been improved.</p>
            <br/>
            <br/>
            <li>The ability to download CSV has been added.</li>
            <li>If you are using pinpad login in the POS, each log in will now be logged on the top right table. Only logins after the first cash in will be logged. If your system is not using pinpad, the first cash in will be logged as the first log in.</li>
            <li>Each Cash In, Cash Drop, and Cash Out are logged individually, with the date and the employee who performed the task.</li>
            <li>On each row, if cash count was done, you can view the cash denominations by clicking "view"</li>
            <li>When the cash register is verified or not verified, the status and the employee who performed the verification will be shown below "Verified expected and actual are equal"</li>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/cashregisterviewenhancement.png" className="imgNewFeatureComponent mt-1" />
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/cashregisterviewenhancement2.png" className="imgNewFeatureComponent mt-1" />
            <br />
            <br />
          </ul>
        </div>)
    },
    {
        title: "Receipt Customization Settings",
        dateAdded: "11/27/2023",
        contents: (<div>
          <ul>
            <p>New settings have been settings for receipts. You can now choose whether to display member name, visit count, and reward points on your receipt.</p>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/receiptsettings.png" className="imgNewFeatureComponent mt-1" />
            <br />
            <br />
          </ul>
        </div>)
    },
    {
        title: "Reorder Report CSV filter.",
        dateAdded: "11/20/2023",
        contents: (<div>
          <ul>
            <p>A filter for Reorder Report has been added for the csv download. </p>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/reorderreportcsvcolumn1.png" className="imgNewFeatureComponent mt-1" />
            <br />
            <br />
            <p>Select the columns you would like to download in your CSV.</p>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/reorderreportcsvcolumn2.png" className="imgNewFeatureComponent mt-1" />
            <br />
            <br />
            <p>Note: The settings for columns to include are saved locally in your device. Clearing browser data will clear the settings.</p>
            <br />
            <br />
          </ul>
        </div>)
    },
    {
        title: "Switch / Remove member in POS",
        dateAdded: "10/12/2023",
        contents: (<div>
          <ul>
            <p>The ability to switch or remove members in the POS.</p>
            <br />
            <br />
            <p>Click on "Remove" or "Change Member" to remove or change member.</p>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/changemember1.png" className="imgNewFeatureComponent mt-1" />
            <br />
            <br />
            <p>Clicking "Change Member" will open the Member Search dialog, where you can search and reassign a new member.</p>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/changemember2.png" className="imgNewFeatureComponent mt-1" />
            <br />
            <br />
          </ul>
        </div>)
    },
    {
        title: "Combo Enhancements",
        dateAdded: "08/31/2023",
        contents: (<div>
          <ul>
            <p>New features have been added to combos</p>
            <br />
            <br />
            <p>1. When you add or save a combo, you can now select the start and end date, start and end time, and the days of week. </p>
            <li>- The combo will no longer show up in the combo list in the POS if current time or day of week is not within the selected range.</li>
            <li>- You can still turn the status of the combo off to inactive even if the current time is within the selected date/time range.</li>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/comboenhancement1.png" className="imgNewFeatureComponent mt-1" />
            <br />
            <br />
            <p>2. New category dropdown has been added to the search function when you add a product to combo.</p>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/comboenhancement2.png" className="imgNewFeatureComponent mt-1" />
            <br />
            <br />
            <p>3. In the POS page, if you add an item that is part of a combo, a notification will show to indicate it is in a combo.</p>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/comboenhancement3.png" className="imgNewFeatureComponent mt-1" />
            <br />
            <br />
            <li>- Clicking on the notification will open the Combo list dialog:</li>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/comboenhancement4.png" className="imgNewFeatureComponent mt-1" />
            <br />
            <br />
            <li>- It will show only the combos that contain the product you clicked on.</li>
            <li>- When you click Add to Order, the combo will be added and the item you clicked on will be removed from the order.</li>
            <li>- If you have multiple items from the same combo already added in the POS, only the item you clicked on will be removed when you add combo to order.</li>
          </ul>
        </div>)
    },
    {
        title: "Receipt Enhancements",
        dateAdded: "08/31/2023",
        contents: (<div>
          <ul>
            <p>Receipts have been improved.</p>
            <br />
            <br />
            <p>1. A new setting have been added to the Settings page. </p>
            <li>- You can now choose whether to show first name or last name of employee on receipts. Turn off both to shown none.</li>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/receiptnamesettings.png" className="imgNewFeatureComponent mt-1" />
            <br />
            <br />
            <p>2. Tips will now be shown on order receipt as well as cashout slips.</p>
            <p>3. Order Date will now be shown on receipt when you print from the Online Order List page.</p>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/receiptprintonline.png" className="imgNewFeatureComponent mt-1" />
            <br />
            <br />
            <p>4. Stacked discount on receipt:</p>
            <li>- Total discounts on products and Total discounts will now show on the bottom summary of the receipt.</li>
            <li>- Multiple discounts will now be listed for per product discounts.</li>
          </ul>
        </div>)
    },
    {
        title: "Member Price Savings",
        dateAdded: "08/21/2023",
        contents: (<div>
          <ul>
            <p>Member price savings have been added to the Order History tab on the members page.</p>
            <br />
            <br />
            <p>Total Member Savings and Savings for each order are shown. It will show savings for all future orders (will not show for old orders).</p>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/memberpricesavings.png"/>
            <br />
            <br />
          </ul>
        </div>)
    },
    {
        title: "Add Payment Method Type to Order List by Online/Instore Report",
        dateAdded: "08/14/2023",
        contents: (<div>
          <ul>
            <p>Payment method, credit card type and is manual approval have been added to the Order List by Online/Instore Report.</p>
            <br />
            <br />
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/paymentmethodonlineinstore1.png" />
            <br />
            <br />
            <p>If there are multiple payment methods, it will show multiple payment methods as well:</p>
            <br />
            <br />
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/paymentmethodonlineinstore2.png" />
            <br />
            <br />
            <p>If we cannot detect which payment card type is for credit card, it will show empty.</p>
          </ul>
        </div>)
    },
    {
      title: "POS Interface Upgrade",
      dateAdded: "07/29/2023",
      contents: (<div>
        <ul>
          <p>Enhanced Filter Visibility: Filters are now hidden by default but can be expanded with the '+' button for a cleaner interface.</p>
          <br />
          <br />
          <p>Simplified Categories View: Removed the title "Categories" for a clutter-free filter section.</p>
          <br />
          <br />
          <p>Expanded Cash Out Window: To provide more clarity, we've increased the size of the Cart window.</p>
          <br />
          <br />
          <p>Visual Product Confirmation: Product images will now appear in the Cash out window once added to an order, helping ensure accuracy.</p>
          <br />
          <br />
          <p>Simplified Sorting: Switched the Sort Buttons to a dropdown format for easier access and to avoid overlapping the categories.</p>
          <br />
          <br />
          <p>More Sorting Options: You can now sort products by "On Sale" items under Sort by Price.</p>
          <br />
          <br />
          <p>**Flexible Weight Options**:
            - Branch-specific weight display: See only the weights your branch uses.
            - Standard weight display: We're now showing the following weights - 0.5g, 1g, 3.5g, 7g, 14g, 28g.
            - Custom weight entry: Apart from hardcoded weights, you can also manually enter a weight value.</p>
          <img src="https://techposdev.blob.core.windows.net/newfeatureimages/posInterfaceUpgrade1.png" className="imgNewFeatureComponent mt-1" />
          <img src="https://techposdev.blob.core.windows.net/newfeatureimages/posInterfaceUpgrade2.png" className="imgNewFeatureComponent mt-1" />
          <img src="https://techposdev.blob.core.windows.net/newfeatureimages/posInterfaceUpgrade3.png" className="imgNewFeatureComponent mt-1" />
          <br />
          <br />
        </ul>
      </div>)
    },
    {
      title: "ECommerce Cosmetics Upgrade",
      dateAdded: "07/28/2023",
      contents: (<div>
        <p>We've recently revitalized our ECommerce platform to enhance the visual appeal and user experience, aiming to boost sales. These design updates not only make the platform more aesthetically cohesive but also ensure that product information is displayed uniformly for the ease of our customers. Below are the details of the implemented improvements.</p>
        <ul>
          <img src="https://techposdev.blob.core.windows.net/newfeatureimages/ecommerce1.png" className="imgNewFeatureComponent mt-1" />
          <p>Uniform Product Cards: We have ensured that all product cards are of a consistent size, providing a more streamlined and organized look.</p>
          <br />
          <br />
          <p>Product Hover Highlight: To help users identify and select products with ease, a border appears around a product card when you hover over it. This border is consistent in size for all products, maintaining uniformity.</p>
          <br />
          <br />
          <p>Standardized Product Names: Product names are now perfectly aligned. This ensures that names line up precisely with the products adjacent to them. A standard height adjustment has been made to achieve this consistency.</p>
          <br />
          <br />
          <p>Aligned Member Prices: All member prices are now neatly aligned, making it easier for users to compare and decide on their purchases.</p>
          <br />
          <br />
          <p>Consistent Sale Price Buttons: Sale price buttons are uniformly positioned, ensuring that users have a coherent visual experience when browsing through multiple products on sale.</p>
          <br />
          <br />
        </ul>
      </div>)
    },
    {
      title: "Custom User Roles",
      dateAdded: "07/28/2023",
      contents: (<div>
        <p>Designed with user security in mind, this new feature allows “Store Owners” to set custom permissions for different roles, such as “Inventory Manager” or “Sales Person”, thereby giving them precise control over which pages and reports each role can access.   This bolsters the security of our platform while also demonstrating TechPOS’s commitment to providing a safe and secure environment for our users.</p>
        <ul>
          <p>Go to the “User Roles List” page, and then click the 3 dots and then “Edit” button for the role you want to manage permissions for. In the example below, we will select the “Inventory Manager”: </p>
          <img src="https://techposdev.blob.core.windows.net/newfeatureimages/customroles1.png" className="imgNewFeatureComponent mt-1" />
          <br />
          <br />
          <p>By using a simple checkbox system, owners can effectively manage the security of their store, ensuring that sensitive information is only accessible to appropriate personnel.  Access will be given to the reports and pages which are checked.   Click on the purple “Save Report Access” or “Save Page Access” buttons to finalize.</p>
          <img src="https://techposdev.blob.core.windows.net/newfeatureimages/customroles2.png" className="imgNewFeatureComponent mt-1" />
          <br />
          <br />
          <p>After roles have been set, the “Inventory Manager” will only be able to see the pages for which they have been granted access by the Store Owner.  For example, if the following 4 pages are granted access:</p>
          <img src="https://techposdev.blob.core.windows.net/newfeatureimages/customroles3.png" className="imgNewFeatureComponent mt-1" />
          <br />
          <br />
          <p>Then the Inventory Manager will see only those 4 pages in the side menu:</p>
          <img src="https://techposdev.blob.core.windows.net/newfeatureimages/customroles4.png" className="imgNewFeatureComponent mt-1" />
          <br />
          <br />
          <p>If the Inventory Manager tries to enter the specific URL for a page for which they have been restricted from accessing for example the “Product Hub”:</p>
          <img src="https://techposdev.blob.core.windows.net/newfeatureimages/customroles5.png" className="imgNewFeatureComponent mt-1" />
          <br />
          <br />
          <p>They will be blocked from accessing the page, and instead of the page, they will see the following message:</p>
          <img src="https://techposdev.blob.core.windows.net/newfeatureimages/customroles6.png" className="imgNewFeatureComponent mt-1" />
          <br />
          <br />
        </ul>
      </div>)
    },
    {
        title: "Auto correct card type for merrco payments",
        dateAdded: "07/27/2023",
        contents: (<div>
            <p>During sale in the POS, if the wrong payment type is selected, We will automatically change the payment type to be correct one. (only debit / credit will be adjusted).</p>
            <ul>
                <p>For online payment, our system will detect if an order is Visa / MasterCard or Amex and automatically save it when the order is prepared. </p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/autocorrectcardtype.png" className="imgNewFeatureComponent mt-1"/>
                <br/>
                <br/>
            </ul>
        </div>)
    },
    {
        title: "Search by UPC filter in Product List and Product Hub",
        dateAdded: "07/26/2023",
        contents: (<div>
            <p>New filters to search by UPC has been added to Product List and Product Hub</p>
            <ul>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/searchbyupcfilter1.png" className="imgNewFeatureComponent mt-1"/>
                <br/>
                <br/>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/searchbyupcfilter2.png" className="imgNewFeatureComponent mt-1"/>
                <br/>
                <br/>
            </ul>
        </div>)
    },
    {
        title: "Points value and visit count on Member List page",
        dateAdded: "07/25/2023",
        contents: (<div>
            <p>You can now view points value and visit count on the member list page</p>
            <ul>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/memberlistpointsvalue.png" className="imgNewFeatureComponent mt-1"/>
                <br/>
                <br/>
            </ul>
        </div>)
    },
    {
        title: "View Order History for assigned member on POS",
        dateAdded: "07/25/2023",
        contents: (<div>
            <p>A button for viewing order history for the assigned member has been added. You can now view order history directly on the POS page.</p>
            <ul>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/assignmembervieworderhistory.png" className="imgNewFeatureComponent mt-1"/>
                <br/>
                <br/>
            </ul>
        </div>)
    },
    {
        title: "Manual Inventory Change report filters",
        dateAdded: "07/19/2023",
        contents: (<div>
            <p>New filters have been added to the Manual Inventory Change report</p>
            <ul>
                <p>Reason filter:</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/manualinventorychange1.png" className="imgNewFeatureComponent mt-1"/>
                <br/>
                <br/>
                <p>Action filter:</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/manualinventorychange2.png" className="imgNewFeatureComponent mt-1"/>
                <br/>
                <br/>
            </ul>
        </div>)
    },
    {
        title: "Inventory Audit enhancement",
        dateAdded: "07/19/2023",
        contents: (<div>
            <ul>
                <p>You can now download csv for each audit on the Audit List page</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/auditdownload.png" className="imgNewFeatureComponent mt-1"/>
                <br/>
                <br/>
                <p>Also, the name of the employee who completed the audit will now be shown on the Audit details page</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/auditdownload2.png" className="imgNewFeatureComponent mt-1"/>
                <br/>
                <br/>
            </ul>
        </div>)
    },
    {
        title: "Member sales report update",
        dateAdded: "07/18/2023",
        contents: (<div>
            <p>The member sales report has been updated.</p>
            <ul>
                <p>Completed date for an order has been added to the downloaded CSV.</p>
                <p>Also, you can now click on the name of member to go to the member details page.</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/membersalesreport.png" className="imgNewFeatureComponent mt-1"/>
                <br/>
                <br/>
            </ul>
        </div>)
    },
    {
        title: "E-commerce Delivery Fee Refund",
        dateAdded: "06/30/2023",
        contents: (<div>
            <p>In the POS, if you would like to refund the shipping cost for an order, you can now use the toggle added in the refund dialog:</p>
            <ul>
                <p>"Refund delivery / Shipping cost" toggle: When the toggle is on, the shipping cost will be included in the refund.</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/refundshippingtoggle.png" className="imgNewFeatureComponent mt-1"/>
                <br/>
                <br/>
            </ul>
        </div>)
    },
    {
        title: "Federal Report enhancement (Manitoba)",
        dateAdded: "06/30/2023",
        contents: (<div>
            <p>The federal report for Manitoba has been updated.</p>
            <ul>
                <p></p>
                <p>For Manitoba, you can input the inventory adjust year, month, and branch</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/mbfederalreport.png" className="imgNewFeatureComponent mt-1"/>
                <br/>
                <br/>
                <p>Also, you can select the month when you click on Inventory Adjust Month:</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/mbfederalreport2.png" className="imgNewFeatureComponent mt-1"/>
                <br/>
                <br/>
            </ul>
        </div>)
    },
    {
        title: "Reorder Report enhancement",
        dateAdded: "06/14/2023",
        contents: (<div>
            <p>The reorder report has been updated.</p>
            <ul>
                <p>Choose a range in the "Historical Data Range" filter to select the range of historical data to use in the report calculation</p>
                <p>Select a PO frequency using the "PO Every" filter. This will affect the recommended reorder quantity.</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/reorderreportenhance.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>Estimated weeks until stock out has also been added. This is calculated using averages of past sales per week depending on historical data range and is only an estimation.</p>
            </ul>
        </div>)
    },
    {
        title: "Weights filter on Product Sales, Daily Inventory Snapshot",
        dateAdded: "06/14/2023",
        contents: (<div>
            <p>You can filter by weights on the Product Sales report and Daily Inventory Snapshot report. Choose a weight from drop down or enter a weight value.</p>
            <ul>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/weightsfilter1.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/weightsfilter2.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Generic accessory product sales feature",
        dateAdded: "06/06/2023",
        contents: (<div>
            <p>The ability to sell accessory products without input the products into the system has been added. Instead of importing all the products first into our system, you can now manually input the product name and price to add these products into the order </p>
            <ul>
                <p>There is a setting called "GeneralAccessorySaleEnabled", default false, if this setting is true, a button called "Accessory Sale' will appear in POS page:</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/genericaccessoryproductsales1.png" />
                <br />
                <br />
                <p>You must have a product with name "Generic Accessory Product" and available stock in your system in order to use this feature, if not, please add this product to the system first, if it can't find, the following dialog will show up:</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/genericaccessoryproductsales2.png" />
                <br />
                <br />
                <p>When you click the button with available products to sell, the dialog below will show up:</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/genericaccessoryproductsales3.png" />
                <br />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/genericaccessoryproductsales4.png" />
                <br />
                <br />
                <p>You need to manually enter the product name, unit price and qty for this product, after you need all the information needed, click confirm, then a product will be added to the order with the name, unit price and qty you input:</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/genericaccessoryproductsales5.png" />
                <br />
                <br />
                <p>The name you input will show up under the lot number field.</p>
            </ul>
        </div>)
    },
    {
        title: "Use barcode scanner on Audit page",
        dateAdded: "05/29/2023",
        contents: (<div>
            <p>You can now use a barcode scanner to scan product into the inventory audit page.</p>
            <ul>
                <p>Ensure the cursor is not inside any text field before scanning.</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/auditscan.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />

            </ul>
        </div>)
    },
    {
        title: "Order List by Online/Instore",
        dateAdded: "05/19/2023",
        contents: (<div>
            <p>You can now filter by Order type in the Order List by Online/Instore report.</p>
            <ul>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/orderlistonelineinstore1.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>If filtering by Online, you can also filter by Order platform and Payment & Delivery.</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/orderlistonelineinstore2.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Preferred Delivery Time (Web Menu)",
        dateAdded: "05/16/2023",
        contents: (<div>
            <p>Preferred Delivery Time” has been added. It allows online customers to set their preferred delivery time when they are checking out on the web menu. </p>
            <p>There are changes in both the TechPOS app, and the Web Menu:</p>
            <ul>
                <h4>TechPOS Features:</h4>
                <p>1. In the Web Menu UI Settings page:  Under 'Delivery Settings' two new dropdown boxes have been added for store to set the "Daily" start and end delivery times.  They will be defaulted to 'Not Set', for stores which do not have delivery, which will cause the Web Menu delivery page to remain the same as it currently is (not display an option for selecting a Preferred Delivery Time when checking out).   The available times are between 8:00 am and 12:00 am midnight.</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/preferreddeliverytime1.png" />
                <br />
                <br />
                <p>An error will display and user will not be able to save the UI settings if either:  (a) Delivery End time is before Delivery Start Time, or (b) One of the times is 'Not set' and the other one is.   If there is an error, it will show in red, and the when the user tries to click the Save button, the screen will scroll to the error so user can fix and then Save again.</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/preferreddeliverytime2.png" />
                <br />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/preferreddeliverytime3.png" />
                <br />
                <br />
                <p>2. In the 'Online Orders Page', when you click on a specific order, the "Preferred Delivery Time" will now display in the details page, see below:</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/preferreddeliverytime4.png" />
                <br />
                <br />
                <p>It will also now show up in the Preparation Page:</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/preferreddeliverytime5.png" />
                <br />
                <br />
                <h4>Web Menu Features:</h4>
                <p>Once the store has set delivery hours in the UI settings, customers will be able to select what their preferred delivery times are, in increments of 30 minutes (note red text which displays the stores' set delivery hours)</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/preferreddeliverytime6.png" />
                <br />
                <br />
                <p>The user can select their time from the list:</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/preferreddeliverytime7.png" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "End of Day report can select multiple branches",
        dateAdded: "05/15/2023",
        contents: (<div>
            <p>On the EOD report, you can now select multiple branches instead of one branch. By default only first branch will be selected</p>
            <ul>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/eodmultibranch.png" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "MultiStore Inventory Management ",
        dateAdded: "05/05/2023",
        contents: (<div>
            <p>A new page under “Inventory” called “Multi Store Management” has been added.</p>
            <ul>
                <p>On the left sidebar, click “Inventory” and then “Multi Store Management”.</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/multistore1.png" />
                <br />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/multistore2.png" />
                <br />
                <br />
                <h4>Main screen</h4>
                <p>The main screen has a header (where you can search and set filters), and a table (where you can view and inventory levels for multiple locations). </p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/multistore3.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <h4>Search and Filters</h4>
                <p>Search Bar:  search by Product Name, Brand or SKU.  Note that the search bar works with partial seaches too (ie.  enter “blue” for all Product Names and Brands which contain “blue”)</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/multistore4.png" />
                <br />
                <br />
                <p>Type Filter:  This allows you to filter by Cannabis, Non-Cannabis, or All (default is set to ‘All’).</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/multistore5.png" />
                <br />
                <br />
                <p>Category Filter:  This allows you to filter by Category.  Note: the options in list will depend on what Type is selected in the ‘Type Filter’ above (default is set to ‘All’).</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/multistore6.png" />
                <br />
                <br />
                <p>Select Location:  This allows you to select which locations will be displayed on the main table below the header (default is set to ‘All’).</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/multistore7.png" />
                <br />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/multistore8.png" />
                <br />
                <br />
                <p>Stock to Display:  This allows you to select either ‘Only-In-Stock’ or ‘All’ (default is set to ‘All’).  When ‘Only-In-Stock’ is selected, only products which have ‘In-Store’ inventory levels greater than 0 will be displayed (default is set to ‘All’).</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/multistore9.png" />
                <br />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/multistore10.png" />
                <br />
                <br />
                <p>Items Per Page:  This allows you to select how many products are displayed in the main table per page.  Options are 20, 50, or 100 per page (default is set to ‘20 per page’).</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/multistore11.png" />
                <br />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/multistore12.png" />
                <br />
                <br />
                <h4>Detailed Product Inventory View (Side drawer)</h4>
                <p>To access: simply click on the “inventory level” for a specific location column, and a drawer will slide open from the right side of the screen which contains a detailed view of that location’s inventory.</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/multistore13.png" />
                <br />
                <br />
                <p>Detailed Product View (drawer):  Here you can view detailed quantities in the warehouse, by (1) Store Inventory, (2) Storage Inventory, and (3) Damage Inventory. </p>
                <p>To the left, there are 2 buttons: </p>
                <p>1. Transfer Button: This button transfers inventory items between the 3 inventory types, or between store locations.  </p>
                <p>2. Low Stock Set Button:  This button sets a new ‘Restock Cap’ which will warn when inventory levels in the store are below that cap amount.  This is the cap that affects the colors in the main table (green, yellow, and red).</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/multistore14.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>Transfer Button:  When this button when clicked, it opens the ‘Transfer Product’ screen as a new pop up window. Within this Transfer Product pop up, you have the option to transfer items between Store, Storage, and Damage within the same location, or between different store locations (branches).</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/multistore15.png" />
                <br />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/multistore16.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>Low Stock Warn Button: In the ‘Set New Cap’ input field, you can set a specific restock cap for the product by typing the new cap amount, and then clicking the ‘Set’ button.  </p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/multistore17.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>Conditional Coloring (based on inventory restock cap):   On the main table view, you’ll notice the green, yellow and red coloring in the inventory quantity columns for each different store location.  When the store inventory level is above the restock cap threshold you’ve set, it will appear gren.  However when the store inventory level falls below the restock cap threshold, the product will appear in yellow on the main screen.  Once the quantity reaches 0, the product will display as red. </p>
                <p>If you do not wish to set a specific threshold for a product, it will always display with a green background when above zero, and when it reaches zero, it will have a white background.  </p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/multistore18.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>Inventory Movement History Chart: Below the transfer and restock cap display is a chart where you can review inventory movement history over time. </p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/multistore19.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>Inventory Movement History Table:  Next is a table containing detailed data for warehouse change log history, for the location you are currently viewing.  You can select the To/From date ranges to filter by any custom time range you wish, and also a dropdown menu to filter by ‘Reason’.  Click ‘Apply Filter’ to apply filters, and the small grey button to remove the filters.</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/multistore20.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Check in search by phone and name",
        dateAdded: "05/02/2023",
        contents: (<div>
            <p>You can now search member by name and phone in check in.</p>
            <ul>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/checkinsearch.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Add member check in feature for POS",
        dateAdded: "04/25/2023",
        contents: (<div>
            <p>There is a new setting called "POSMemberCheckInEnabled", default is false, once it's set to be true, there will be a new icon showing in the header section of POS</p>
            <ul>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/membercheckinPOS1.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/membercheckinPOS2.png" />
                <br />
                <br />
                <p>When you click on the icon, the dialog will pop up and you can check in members before they go to POS:</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/membercheckinPOS3.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>You can input the member id to add the member to the check-in list:</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/membercheckinPOS4.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>Then later, when customers are coming to pay in POS, you can click on the check in icon again and you will see a "start order" button:</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/membercheckinPOS5.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>Once you click on this start order button, a POS order will be created with the link to this member.</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/membercheckinPOS6.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Product by Category enhancement",
        dateAdded: "04/25/2023",
        contents: (<div>
            <p>The product by category report has been updated.</p>
            <ul>
                <p>You can now select cannabis/non-cannabis, as well as product category. You can also now select a date for comparison (more on this below).</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/productbycategory1.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>A new plot for each category has been added.</p>
                <p>On the top right, select the plot you would like to see.</p>
                <p>On the bottom left, click on the check box to show comparison with the chosen comparison date.</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/productbycategory2.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/productbycategory4.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>The report has also been updated to show Units, total cost in inventory, Margin %, and Markup %</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/productbycategory3.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>Clicing the comparison checkbox will also show the comparison data in the table</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/productbycategory5.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Budtender Average Sales report enhancement",
        dateAdded: "04/19/2023",
        contents: (<div>
            <p>The budtender Average Sales report has been updated with new plot and UI, as well as new information for each budtender.</p>
            <ul>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/budtenderavgsalesnew1.png" />
                <br />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/budtenderavgsalesnew2.png" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "New Monthly Inventory Report",
        dateAdded: "04/13/2023",
        contents: (<div>
            <p>A new monthly inventory report has been added, with information on opening and closing inventory, orders, cost of goods sold, and adjustments.</p>
            <ul>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/monthlyinventorynew.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Sales by Category report enhancements",
        dateAdded: "04/11/2023",
        contents: (<div>
            <p>The Sales by Category report has been updated.</p>
            <ul>
                <li>You can now filter by "Type" (Cannabis/Non-Cannabis)</li>
                <li>The Report By filter affects the plot (see below)</li>
                <li>The "Include Product Summary in CSV" checkbox will include the product summaries for each category (also see below)</li>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/salesbycategoryenhancement1.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <li>A new plot showing daily/weekly/monthly (depends on your filter above) net sales for each category has been added. It will show data from the date range you have selected, up until the most recent 30 dates.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/salesbycategoryenhancement2.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <li>The report now shows parent category and sub-category summaries.</li>
                <li>For each sub-category, click on "View" to view product summary for that sub-category.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/salesbycategoryenhancement3.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/salesbycategoryenhancement4.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Purchase Order Receiver report enhancement",
        dateAdded: "04/03/2023",
        contents: (<div>
            <p>The Purchase Order Receiver report has been updated.</p>
            <ul>
                <li>The package reference of the purchase order has been added to the report:</li>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/purchaseorderrecieverreport1.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <li>You can also now click on the purchase order number to go to the actual purchase order details page.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/purchaseorderrecieverreport2.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Product Sales report enhancement",
        dateAdded: "03/24/2023",
        contents: (<div>
            <p>The Product Sales report has been updated.</p>
            <ul>
                <p>A new summary for taxes, discount, deposit amount, and gross sales has been added to the top of the report.</p>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/productsalesreportenhancement1.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <p>Click on the "Show summary by category" button to show summary by category</p>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/productsalesreportenhancement2.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Tips Feature",
        dateAdded: "03/21/2023",
        contents: (<div>
            <h5>A new feature to add tips has been added.</h5>
            <h5>For moneris:</h5>
            <ul>
                <li>To add tips in a moneris machine, there is a button in POS page called “set pinpad tip”. Click this button to set up the tips one time.</li>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/tipsfeature1.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <li>In the dialog that opens, select the tip option you want to set:</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/tipsfeature2.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/tipsfeature3.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <li>After you select and click confirm, the tip option will be added to the machine automatically.</li>
            </ul>
            <h5>For Merrco:</h5>
            <ul>
                <li>To enable tips in-store: You can enable the tip prompt directly from the terminal.</li>
                <li>No information needs to be sent through the API.</li>
                <li>The customer will be prompted for a tip when completing the sale</li>
            </ul>
            <h5>To enable tips for a920:</h5>
            <ul>
                <li>Switch the Payfacto APP (standalone mode)</li>
                <li>Select the "+" icon at the bottom</li>
                <li>Select Settings</li>
                <li>Enter admin password</li>
                <li>Select Terminal Options</li>
                <li>Scroll down to Tip Processing</li>
                <li>Enable tip by sliding the toggle over</li>
                <li>After the tip is set up successfully, the tips will pop up when the amount is sent to the pinpad. After the payment is complete, the tip amount will appear in the POS page as well.</li>
            </ul>
            <br />
            <h5>You can also add / edit tip manually as well.</h5>
            <ul>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/tipsfeature4.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
            <h5>For webmenu:</h5>
            <ul>
                <li>You can select tip percentage or a custom amount.</li>
                <li>The total amount including the tips will be pushed to our POS after the payment is complete.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/tipsfeature5.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
            <h5>Report:</h5>
            <ul>
                <li>The tip for the date range will show under payment section in the End of Day report:</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/tipsfeature6.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Schedules enhancements: Monthly total and Precreated Time slots",
        dateAdded: "03/20/2023",
        contents: (<div>
            <p>Monthly hours for each employee has been added to the monthly schedule view:</p>
            <ul>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/scheduleprecreatedslot1.png" className="imgNewFeatureComponent mt-1" />
            </ul>
            <br />
            <br />
            <p>A new feature for adding customized precreated time slot has also been added</p>
            <ul>
                <li>Click on the "Set Up Time Slot" button to open up a new dialog:</li>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/scheduleprecreatedslot2.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <li>Add a new time slow by choosing the start and end time, then click "Add". It will show up on the list below. To delete a time slot, click on the trash button</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/scheduleprecreatedslot3.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <li>Once you have added the time slots, you can choose the time slot from the dropdown when you add a new schedule. It will automically fill in the start and end time.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/scheduleprecreatedslot4.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/scheduleprecreatedslot5.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <li>You can choose the time slots for recursive schedules as well.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/scheduleprecreatedslot6.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Discount Margin Warning Messages",
        dateAdded: "03/20/2023",
        contents: (<div>
            <p>A warning message will now show if the manual discount (Amount or Percnetage) you have entered drops your profit to below 15% or below the cost of the product or order.</p>
            <ul>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/discountmarginmessage2.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/discountmarginmessage1.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <li>Similar warning messages will also show for individual product discounts and for customized discounts.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/discountmarginmessage3.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/discountmarginmessage4.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Supplier Invoice Number for Purchase Orders",
        dateAdded: "03/17/2023",
        contents: (<div>
            <p>You can now enter the supplier invoice number when placing a purchase order or editing an old purchase order</p>
            <ul>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/supplierinvoicenumber2.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <li>Once you have eneterd the supplier invoice number for the PO, it will appear in the Purchase Order Report</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/supplierinvoicenumber.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Discount report enhancements",
        dateAdded: "03/13/2023",
        contents: (<div>
            <p>The Discount report has been updated with new filters as well as summary and breakdown of different types of discounts</p>
            <ul>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/discountreportenhancement.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/discountreportenhancement2.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <li>Click on each tab of the summary to switch view:</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/discountreportenhancement3.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Business insights sales plot",
        dateAdded: "02/15/2023",
        contents: (<div>
            <p>The sales plot on the Business Insights page has been improved to show previous day/week/month sales.</p>
            <ul>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/businessinsightssalesplot1.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/businessinsightssalesplot3.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/businessinsightssalesplot2.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Total hours on weekly schedule",
        dateAdded: "02/07/2023",
        contents: (<div>
            <p>On the bottom of the weekly view in the schedule page, a new table totaling the hours for each employee has been added.</p>
            <ul>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/weeklyscheduletotalhours.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Inventory Transfer report cannabis filter",
        dateAdded: "02/01/2023",
        contents: (<div>
            <p>A new filter for cannabis/non-cannabis has been added to inventory transfer report.</p>
            <ul>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/inventorytransfercannabisfilter.PNG" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Bulk transfer CSV upload and download",
        dateAdded: "02/01/2023",
        contents: (<div>
            <p>The the ability to upload products for bulk transfer using a csv file has been added.</p>
            <ul>
                <li>In the New bulk transfer page or the Bulk transfer edit page, you can download a csv template</li>
                <li>Click on Import product from excel to upload products</li>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/bulktransfercsv1.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <li>A new dialog will show up detailing the products you have added.</li>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/bulktransfercsv2.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <li>The products will be added once you click add.</li>
                <li>If a package reference you entered in the CSV does not have enough quantity in the current warehouse or you did not enter a package reference, you will need to select a package reference manually.</li>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/bulktransfercsv3.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <li>On the bulk transfer view page, a new button to download a csv file for the details of the bulk transfer has also been added</li>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/bulktransfercsv4.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Gift card sale with variable gift card amount",
        dateAdded: "01/30/2023",
        contents: (<div>
            <p>The the ability to sell gift cards with a variable amount has been added.</p>
            <ul>
                <li>In the gift card of POS:</li>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/giftcardsalevariable1.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <li>You must first create a new product with name "GIFT CARD VARIABLE AMOUNT", set the price to be $0.01 and make sure it has inventory to sell by adding the product to a purchase order and receiving it.</li>
                <li>When you click the gift card button, a new option with name "add gift card to order" will show up:</li>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/giftcardsalevariable2.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <li>When you click this button, this dialog will pop up:</li>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/giftcardsalevariable3.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <li>You can specify the amount, for example $20, then click "confirm", a gift card with $20 will be added to the order.</li>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/giftcardsalevariable4.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <li>After the payment is done, you can only activate a gift card with $20, which is the amount  you input previously.</li>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/giftcardsalevariable5.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "New process for inventory audit",
        dateAdded: "01/28/2023",
        contents: (<div>
            <p>The process for inventory audit has been updated.</p>
            <ul>
                <li>The inventory audit verify page no longer existing anymore, all inventory audit process will be done in one page.</li>
                <li>When you click "add new audit', you need to input a name for the audit first.</li>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/inventoryauditnewprocess1.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <li>After you click "confirm", the audit will be created with no products inside, you can add products to the audit same as before.</li>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/inventoryauditnewprocess2.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <li>If your role is "store manager" or "owner", you will have the ability to see "expected qty, difference, total cost difference', and the complete button at the top.</li>
                <li>"Store manager" or "Owner" has the ability to complete the audit, salesperson does not.</li>
                <li>After you add products to the audit:</li>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/inventoryauditnewprocess3.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <li>If you don't input qty, we won't show the difference qty/ difference cost, it will show when you input the qty different from the expected qty.</li>
                <li>There will be no save button in this page, the "current qty", "notes" and "audit name' will be saved at real time automatically when you blur the amount.</li>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/inventoryauditnewprocess4.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <li>When the system is updating the qty/ notes/ name, the input boxes will be disabled, when the updates is done, the input boxes will be active again.</li>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/inventoryauditnewprocess5.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <li>After you complete the inventory audit, you can't change the current qty anymore, but you can still change the notes and change the audit name.</li>
                <li>There is a search bar that you can filter the products in the audit by names.</li>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/inventoryauditnewprocess6.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Ability to sell products without inventory",
        dateAdded: "01/27/2023",
        contents: (<div>
            <ul>
                <li>the ability to sell products without inventory when the setting "SaleDeductInventoryAfterPayment" is ON has been added.</li>
                <li>When this setting is ON, we will show the 0 quantity in POS:</li>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/saledeductinventoryafterpayment.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <li>You can add 0 qty product to the order, our system will automatically adjust the quantity of the product by +1 and -1 after the payment is done.</li>
                <br />
            </ul>
        </div>)
    },
    {
        title: "Email marketing enhancement",
        dateAdded: "01/24/2023",
        contents: (<div>
            <ul>
                <li>The email marketing function has been enhanced.</li>
                <li>You can now add formatting as well as link images and add hyperlinks.</li>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/emailmarketingenhance.png" className="imgNewFeatureComponent mt-1" />
                <br />

            </ul>
        </div>)
    },
    {
        title: "Bulk transfer page filters",
        dateAdded: "01/17/2023",
        contents: (<div>
            <ul>
                <li>New date and status filters have been added to the bulk transfer list page.</li>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/bulktransferdatestatusfilters.png" className="imgNewFeatureComponent mt-1" />
                <br />

            </ul>
        </div>)
    },
    {
        title: "Bulk transfer enhancements",
        dateAdded: "01/09/2023",
        contents: (<div>
            <ul>
                <li>You can now click view completed bulk transfers by clicking on View</li>
                <li>The total cost for each bulk transfer has also been added to the list</li>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/bulktransferviewcompleteandtotalcost.png" className="imgNewFeatureComponent mt-1" />
                <br />

            </ul>
        </div>)
    },
    {
        title: "Product Hub filter for in stock",
        dateAdded: "01/09/2023",
        contents: (<div>
            <ul>
                <li>A new filter for showing only in stock products have been added to the product hub page.</li>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/producthubfilterinstock.png" className="imgNewFeatureComponent mt-1" />
                <br />

            </ul>
        </div>)
    },
    {
        title: "End Of Day report enhancements",
        dateAdded: "01/06/2023",
        contents: (<div>
            <p>A number of enhancements have been added to the end of day report.</p>
            <ul>
                <li>Added "gross sales" to the report</li>
                <li>Added "COGs" to the report</li>
                <li>Added "total penny adjustment" to the order, it's a new filed for each order, if the payment is smaller than the total amount and the shortage is less than 5 cents, we will automatically complete the order and record the penny adjust as a negative number. and the "total penny adjustment" showing here will be the sum value of all the penny adjustments for this day.</li>
                <li>Show "main category" which is the sales for accessory and cannabis</li>
                <li>Added the refund method and amount. (gift card may show in here as well)</li>
                <li>The gift card payment will show under the payment methods if there is any</li>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/eodenhancement1.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/eodenhancement2.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/eodenhancement3.png" className="imgNewFeatureComponent mt-1" />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Gift card activation after payment",
        dateAdded: "12/7/2022",
        contents: (<div>
            <ul>
                <li>For any gift card activation / reload, if the employee is a sales person in the system, they can only do it after the payment is done.</li>
                <li>This change will be applied for Moneris/ paystone / birchmount gift integration.</li>
                <br />
                <li>They need to click the "ACTIVATE / RELOAD" button beside the product to activate or reload card.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/giftcardafterpayment1.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <li>After they click, the pop up dialog will have the activation amount with a fixed value:</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/giftcardafterpayment2.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <li>For sales person, they can't do the activation without the order to be completed:</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/giftcardafterpayment3.png" className="imgNewFeatureComponent mt-1" />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Delivery Report",
        dateAdded: "12/7/2022",
        contents: (<div>
            <ul>
                <li>A new report for online orders requiring delivery for the day has been added.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/delivery.png" className="imgNewFeatureComponent mt-1" />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Search member by card number",
        dateAdded: "11/30/2022",
        contents: (<div>
            <ul>
                <li>Ability to search members by card number has been added.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/cardnumbersearch.png" className="imgNewFeatureComponent mt-1" />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Gift card history",
        dateAdded: "11/30/2022",
        contents: (<div>
            <ul>
                <li>Report for gift card history has been added.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/giftcard.png" className="imgNewFeatureComponent mt-1" />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Transaction dashboard averages",
        dateAdded: "11/28/2022",
        contents: (<div>
            <ul>
                <li>Averages for week and day sections on transaction dashboard on the main page has been added.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/averageweekandday.png" className="imgNewFeatureComponent mt-1" />
                <br />
            </ul>
        </div>)
    },
    {
        title: "End of Day report date range",
        dateAdded: "11/28/2022",
        contents: (<div>
            <ul>
                <li>You can now select a begin and end date for the End of Day report.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/eodreportdate.png" className="imgNewFeatureComponent mt-1" />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Purchase order receiver report",
        dateAdded: "11/28/2022",
        contents: (<div>
            <ul>
                <li>New purchase order receiver report has been added.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/poreceiver.png" className="imgNewFeatureComponent mt-1" />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Member ID when adding new member on POS page",
        dateAdded: "11/28/2022",
        contents: (<div>
            <ul>
                <li>When adding a new member on the POS page, a new message is now shown with the member ID of the newly added member.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/posaddmember.png" className="imgNewFeatureComponent mt-1" />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Ability to set campaign by time range, and allow campaign for online orders only",
        dateAdded: "11/28/2022",
        contents: (<div>
            <ul>
                <li>In campaign create/edit page, there is a field for customers to select the start time and end time of the campaign,
                    if it's null, the campaign will be available all day. If both start time and end time are filled (you can't only fill start time or end time),
                    the campaign will start at the start time and end at the end time.</li>
                <li>There is a toggle button called "apply online only", once this toggle is set to be yes, the campaign will only be applied online.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/campaigntimerange.png" className="imgNewFeatureComponent mt-1" />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Bulk product decimal number",
        dateAdded: "11/24/2022",
        contents: (<div>
            <ul>
                <li>The ability to ability to input decimal numbers for bulk products has been added.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/bulkproductdecimal.png" className="imgNewFeatureComponent mt-1" />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Hourly Sales Averaged charts",
        dateAdded: "11/23/2022",
        contents: (<div>
            <ul>
                <li>Charts for Hourly Sales Averaged report has been added.</li>
                <li>Use the checkboxes to select which data to plot.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/hourlysales1.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/hourlysales2.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/hourlysales3.png" className="imgNewFeatureComponent mt-1" />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Report date validation",
        dateAdded: "11/22/2022",
        contents: (<div>
            <ul>
                <li>There is now an error message for invalid date ranges in report pages</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/reportdaterange.PNG" className="imgNewFeatureComponent mt-1" />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Inventory audit sorting",
        dateAdded: "11/21/2022",
        contents: (<div>
            <ul>
                <li>You can now sort by product name and SKU on the inventory audit page.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/inventoryauditsort.png" className="imgNewFeatureComponent mt-1" />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Error message for existing email",
        dateAdded: "11/21/2022",
        contents: (<div>
            <ul>
                <li>Proper error message has been added if a new employee is added with an email that already exist in the database.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/existingemail.png" className="imgNewFeatureComponent mt-1" />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Aggregate branches report download",
        dateAdded: "11/21/2022",
        contents: (<div>
            <ul>
                <li>A download CSV button has been added to aggregate branches report.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/aggregatebranch.png" className="imgNewFeatureComponent mt-1" />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Add products in bulk transfer by scanning",
        dateAdded: "11/21/2022",
        contents: (<div>
            <ul>
                <li>The ability to scan to add products has been added to both bulk transfer create and edit page</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/bulktransfer1.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/bulktransfer2.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/bulktransfer3.png" className="imgNewFeatureComponent mt-1" />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Lock Out",
        dateAdded: "10/28/2022",
        contents: (<div>
            <ul>
                <li>When employee or web user enters the wrong password 5 times they are logged out.
                    From POS an administrator needs to unlock</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/LockOut1.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/LockOut2.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/LockOut3.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/LockOut4.png" className="imgNewFeatureComponent mt-1" />
            </ul>
        </div>)
    },
    {
        title: "POS Clear Button",
        dateAdded: "10/28/2022",
        contents: (<div>
            <ul>
                <li>Clears search text, thc cbd slider, category/sub category selections</li>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/POSClearButton.png" className="imgNewFeatureComponent mt-1" />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Hourly Sales by Date Range",
        dateAdded: "10/28/2022",
        contents: (<div>
            <ul>
                <li>Sales information by day and by hour – on days with sales</li>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/HourlySalesByDateRange.png" className="imgNewFeatureComponent mt-1" />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Budtender Average Sales Report",
        dateAdded: "10/28/2022",
        contents: (<div>
            <ul>
                <li>Before: look at all cash registers and get the employees that created cash registers – look in orders table for sales by those employees.
                    New: Consider all employees – collect cash register total amount and assign that info to an employee-collect all info from orders table and assign that to employee.
                    So we now list all employees and cash register totals for employees that opened cash registers, and their order information.</li>
                <br />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/BudtenderAverageSalesReport.png" className="imgNewFeatureComponent mt-1" />
                <br />
            </ul>
        </div>)
    },
    {
        title: "New Delivery/Shipping Page",
        dateAdded: "10/21/2022",
        contents: (<div>
            <ul>
                <li>Province is set.</li>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/NewDeliveryShippingPage.png" className="imgNewFeatureComponent mt-1" />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Hourly Sales Averaged Report",
        dateAdded: "10/21/2022",
        contents: (<div>
            <ul>
                <li>Takes a date range, and determines hourly average of various information.</li>
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/HourlySalesAveragedReport.png" className="imgNewFeatureComponent mt-1" />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Inventory Age Report",
        dateAdded: "10/19/2022",
        contents: (<div>
            <ul>
                <li>The inventory age report has an issue when a package reference has inventory and that inventory reaches zero. Then more inventory is received with the same package reference.
                    The old report would show the inventory age as from the first PO received.
                    The inventory age report now shows the age as the first PO received date after AllwarehouseQuantity reaches zero.</li>
                <br />
            </ul>
        </div>)
    },
    {
        title: "Bulk Update Member Price Feature",
        dateAdded: "10/14/2022",
        contents: (<div>
            <ul>
                <li>In inventory adjust page, there is a new button called "update all member prices".</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/BulkUpdateMemberPrice1.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <li>Once you click it, there will be a dialog pop up for the percentage of the member price update:</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/BulkUpdateMemberPrice2.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <li>the default value will be the value in the setting update page for the "Member discount percentage":</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/BulkUpdateMemberPrice3.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <li>When you click "CONFIRM" in the "confirm bulk update member price" dialog, the pricing update will start, and it will take a while for the update to be done. After that, the member price (which is the price when order is linked to a member) will be different from regular price, and it's not considered as a discount, which means they can apply one more discount in our system.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/BulkUpdateMemberPrice4.png" className="imgNewFeatureComponent mt-1" />
            </ul>
        </div>)
    },
    {
        title: "Add Shipping Cost Button in POS",
        dateAdded: "9/30/2022",
        contents: (<div>
            <ul>
                <li>There will be a new button in POS appear called "add/edit shipping cost"</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/AddShippingCostButtonPOS1.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <li>When people click on it, there will be a dialog pop up and people can manually edit the shipping/delivery cost for this order.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/AddShippingCostButtonPOS2.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <li>If people want to refund the delivery cost, they can just set this value to 0, even after the order is completed, they can do the edit for this value.</li>
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Online Orders Page Print Button",
        dateAdded: "9/28/2022",
        contents: (<div>
            <ul>
                <li>Now have the ability to print an online order receipt from the online order list page.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/OnlineOrdersPagePrintButton.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Assign a Member to Completed Order",
        dateAdded: "9/28/2022",
        contents: (<div>
            <ul>
                <li>Assign Member Button now shows for Completed Order without a Member assigned:</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/AssignAMembertoCompletedOrder1.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <li>Click the button and the member search dialog opens:</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/AssignAMembertoCompletedOrder2.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <li>Assign a member and they get visit points, reward point and a completed orders increment for this order:</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/AssignAMembertoCompletedOrder3.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "On-Hold Filter Warehouse Page",
        dateAdded: "9/23/2022",
        contents: (<div>
            <ul>
                <li>All products: It will show all products.</li>
                <li>By on hold: it will show all products with on hold products.</li>
                <li>By no on hold: it will show all products with no on hold products.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/OnHoldFilterWarehousePage.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Online Orders",
        dateAdded: "9/16/2022",
        contents: (<div>
            <ul>
                <li>Advanced Search options have been added to the Online Orders page: First Name, Last Name, Email, Phone Phone can be entered with any combination of  ( ) -, these characters are removed when searching by phone number</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/OnlineOrders1.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <li>Delivery Fee and Shipping Cost have been added to the order details page, it displays for orders with shipping or delivery instructions. Previously the delivery/shipping info was missing and the subtotal + taxes did not add up the total displayed for shipping/delivery orders. With a deployment of this upgrade, all previous orders will use the database information and the amounts will display correctly.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/OnlineOrders2.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/OnlineOrders3.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Bulk Transfer - Transfer On-hold",
        dateAdded: "9/9/2022",
        contents: (<div>
            <ul>
                <li>We added a setting per Transfer called Need Receive: The default value is false.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/BulkTransferTransferOnHold1.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <li>After we create the transfer with Need receive, the transfer is added to the bulk transfer list.
                    The transfer will have the buttons Edit and Transfer. The customer can edit the transfer still at this point.
                    The previous process is still up if customers want to use it as well.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/BulkTransferTransferOnHold2.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <li>When the customer will press the button Transfer, the products in the bulk transfer will be transferred to the Storage in the same branch will be sent.
                    The button will show up a message confirming with our customer that they want to transfer those products to Storage temporarily.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/BulkTransferTransferOnHold3.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <li>After we transfer the products to the temporal warehouse, the status of the transfer will be Need receive, this meant that the customer needs to receive the products in the right warehouse.
                    The customer could see the bottom Edit and Receive.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/BulkTransferTransferOnHold4.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <li>At this point, the customer cannot edit the transfer because the products are already transferred to the new branch, but they are able to look at the transfer.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/BulkTransferTransferOnHold5.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <li>Finally, when the customer press the button Revecive the products will be sent to the right warehouse. A dialog will show up with the transfer details before transferring it.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/BulkTransferTransferOnHold6.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Product Category Report",
        dateAdded: "9/9/2022",
        contents: (<div>
            <ul>
                <li>The request was from 24 karats, they want a count of products in each category. Totally independent of price this count, independent of weight as well. And they wanted to see the total cost of all products in a category.
                    This works for past dates as well, the data about a past date. The code is modelled from the Daily Inventory Snapshot, so that the results line up.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/ProductCategory Report.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Clear unprinted orders - Online orders Page",
        dateAdded: "9/1/2022",
        contents: (<div>
            <ul>
                <li>We got a request for clearing the Unprinted order list on Online Order Page. We added a button on that page to not print the orders that haven’t been printed until that moment.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/ClearUnprintedOrdersOnlineOrdersPage1.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <li>When you press the button, a dialog will show up confirming this action.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/ClearUnprintedOrdersOnlineOrdersPage2.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <li>Another dialog will show up with a message of the result of that action.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/ClearUnprintedOrdersOnlineOrdersPage3.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/ClearUnprintedOrdersOnlineOrdersPage4.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Show Sold-out Products Online",
        dateAdded: "8/29/2022",
        contents: (<div>
            <ul>
                <li>In inventory adjustment page, there is a new field in ecommerce section:</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/ShowSoldoutProductsOnline1.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <li>the name is "show after sold out". It's a boolean toggle that can be either true or false (default false), if people want to show the product even after it's sold out, they need to manually set this property to be "true" for specific products.</li>
                <li>After this field is set to be true, here is what it will show in web menu:</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/ShowSoldoutProductsOnline2.png"
                    className="imgNewFeatureComponent mt-1" />
                <br />
                <li>Instead of "add to cart', it will show "view product".</li>
                <br />
                <li>When you click "view product", it will show "sold out" in the product detail page:</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/ShowSoldoutProductsOnline3.png"
                    className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },

    {
        title: "Filter in Marketing Page",
        dateAdded: "8/22/2022",
        contents: (<div>
            <ul>
                <li>A filter was added to the Marketing Page header, this filter contains : Name, Last Name, Email, Phone Number, Gender</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/FilterinMarketingPage.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Reward Points",
        dateAdded: "8/20/2022",
        contents: (<div>
            <ul>
                <li>If the budtender removes the discount from the order, the reward points get returned to the customer.</li>
                <li>When an order is completely refunded, reward points gained from the purchase are deducted from the member’s reward points.</li>
                <li>If a customer uses reward points to get a discount on their order, and that order is fully returned. The points used for the discount in the order are returned to the customer.</li>
                <li>All point deductions or additions are tracked in the POINTS HISTORY of the member profile.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/RewardPoints.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />

            </ul>
        </div>)
    },
    {
        title: "Inventory Trend by Sale - (Re-Order Report)",
        dateAdded: "8/16/2022",
        contents: (<div>
            <ul>
                <li>Some changes to the Inventory Trend By Sale (Re-Order Report) Requested by customers</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/InventoryTrendBySaleReOrderReport1.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <li>When a report is retrieved use the “Only show products with inventory or purchased recently (within 30 days)” to filter out products that have inventory or haven’t sold in the last 30 days.The show inception data checkbox will show/hide since inception data. Since inception means since first ordered. Since inception data includes: First order date, days in stock, Total sold, Average sales per day, Days to sell 10 units.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/InventoryTrendBySaleReOrderReport2.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <li>Profit Margin is the same as profit margin from Inventory Adjust/Product Hub.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/InventoryTrendBySaleReOrderReport3.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <li>Price, thc_exact, and cbd_exact were added to the report csv.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/InventoryTrendBySaleReOrderReport4png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />

            </ul>
        </div>)
    },
    {
        title: "IRCC Report",
        dateAdded: "8/16/2022",
        contents: (<div>
            <ul>
                <li>This report generates the Alberta Federal Monthly report for all customers in the csv format, just like our other reports.
                    It is very simple, it does not have a report display page, just a search header and csv download.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/IRCCReport1.png" className="imgNewFeatureComponent mt-1" style={{ height: 'auto', width: '250px' }} />
                <br />
                <br />
                <li>The data matches the Alberta Federal Report.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/IRCCReport2.png" className="imgNewFeatureComponent mt-1" style={{ height: 'auto', width: '950px' }} />
                <br />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Show member price/regular price differently in web menu",
        dateAdded: "07/11/2022",
        contents: (<div>
            <ul>
                <li>In menu/carousel/product detail page, if the member price is different from regular price, it will show like this:</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/member_price_regular_price_1.png" className="imgNewFeatureComponent mt-1" style={{ height: 'auto', width: '250px' }} />
                <br />
                <br />
                <li>If there is a campaign:</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/member_price_regular_price_3.png" className="imgNewFeatureComponent mt-1" style={{ height: 'auto', width: '950px' }} />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Add Inventory Age Report",
        dateAdded: "07/07/2022",
        contents: (<div>
            <ul>
                <li>A new report called "Inventory Age is added":</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/inventoryAge.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <br />
                <li>There are some filters for this report:</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/inventoryData.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <li>all have to be manually entered.</li>
                <li>The data will looks like following:</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/inventoryReport.png" className="imgNewFeatureComponent mt-1" />
                <li>We will show the quantity on hand for that lot number of those products.</li>
                <li>there may be multiple rows for one product if there are multiple lot numbers for that product.</li>
                <li>The result is sorted by inventory age desc.</li>
                <br />
            </ul>
        </div>)
    },
    {
        title: "Demographic report",
        dateAdded: "07/04/2022",
        contents: (<div>
            <ul>
                <li>new report which shows 2 charts: one for showing the percentage of people according to gender, and another for showing the percentage of people according to age range.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/memberDemographic.jpg" className="imgNewFeatureComponent mt-1" />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/memberAgeGender.jpg" className="imgNewFeatureComponent mt-1" />
                <br />
                <li>In addition, we changed the gender option that our customers got when they add a new member to the POS.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/memberGender.jpg" className="imgNewFeatureComponent mt-1" />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Add vendor catalog list feature",
        dateAdded: "06/29/2022",
        contents: (<div>
            <ul>
                <li>Added the vendor accessory feature to our system, here is what I have done:</li>
                <li>Move the vendor list to a separate section called "Vendor":</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/vendor.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <li>There is a new tab called "accessory vendor catalog"</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/vendorcatalog.png" className="imgNewFeatureComponent mt-1" />
                <li>Once people click on that, they will see a list of catalogs that are integrated with us, they can either shop online, which will navigate them directly to the accessory site, or they can click "import products to techpos", which will import the catalog to their system, a dialog will pop up and users will be notified that they catalog will be imported within 24 hours.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/vendorpage.png" className="imgNewFeatureComponent mt-1" />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Several updates for the system",
        dateAdded: "06/23/2022",
        contents: (<div>
            <ul>
                <li>In budtender avg sales report, I have added the a new filed called "average transaction speed per order":</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/budtenderReport.png" className="imgNewFeatureComponent mt-1" />
                <li>It's showing below the timesheet filled.</li>
                <br />
                <li>There is a new filed called "reason text" in manual inventory adjustment report:</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/reasonText.png" className="imgNewFeatureComponent mt-1" />
                <li>It will show the reason of that adjustment.</li>
                <br />
                <li>When the cash drawer pop up opens, it will open in the very top of the page, it will prevent people not able to see the change value:</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/cashDrawer.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <li>In mobile version, the device save button will be over lapped by the chat bot, we have move the save button to the middle side to avoid this issue:</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/saveBtnMobile.png" className="imgNewFeatureComponent mt-1" />
            </ul>
        </div>)
    },
    {
        title: "Filter by brand and Species, Warehouse",
        dateAdded: "06/23/2022",
        contents: (<div>
            <ul>
                <li>Added 2 new filter fields on the Warehouse Page: Brand and Species.</li>
                <li>For filtering by brand, you must type the brand name.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/warehouseBrand.jpg" className="imgNewFeatureComponent mt-1" />
                <br />
                <li>For filtering by Species, you must select one of the options you got in the selection input.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/warehouseSpecies.jpg" className="imgNewFeatureComponent mt-1" />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Bulk Transfer",
        dateAdded: "06/22/2022",
        contents: (<div>
            <ul>
                <li>The new transfer page allows us to create a new transfer. We must select the branch and the warehouse on your left side first to be able to search for products. You also must select the branch and warehouse you are transferring the products. On the right side, you have to type a title and select your products to transfer.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/bulkTransfer.jpeg" className="imgNewFeatureComponent mt-1" />
                <br />
                <li>You got 2 options to select products: by-product or by PO. If the product has 0 units, your product wont be added. Also, you have the chance to select between PO numbers and delete a product from the transfer.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/bulkDetails.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <li>You also can add a product from a PO number, you will see a dialog with a search section, after you find a PO, you will look at it in the table inside the dialog. Each PO in the list has 2 actions: Look at the products that the PO selected contents and add products to the current transfer. If the Product is not in the Branch a warehouse will not be added. Also, if the product has 0 units.</li>
                <li>When you select a product with more than 1 Package reference you must select one reference, after that, you will see the quantity of that product.</li>
                <li>On the bulk transfer page, you can find all transfers done previously. Also, you can filter by branch. Each transfer has 2 actions, edit, and confirm a transfer</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/bulkList.jpeg" className="imgNewFeatureComponent mt-1" />
                <br />
                <li>To edit one transfer that hasnt been confirmed, you can press the button Edit and You will be able to delete and add more products. Same as the create bulk transfer page.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/bulkEdit.jpeg" className="imgNewFeatureComponent mt-1" />
                <br />
                <li>And last, we can confirm a transfer on the Bulk transfer page. You will see a Dialog with the Transfer information and the button “Confirm”. After this action, the transfer will have the status of completed.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/bulkConfirm.jpeg" className="imgNewFeatureComponent mt-1" />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/BulkDone.jpeg" className="imgNewFeatureComponent mt-1" />
            </ul>
        </div>)
    },
    {
        title: "Show member price as discounted price in POS page and receipt",
        dateAdded: "06/20/2022",
        contents: (<div>
            <ul>
                <li>There is a new setting called: "ShowOriginalNonMemberPrice", default false, if this setting is turned to be true, we will show the following</li>
                <li>In POS page, we will show the member price and regular price together, and the regular price will be showing as discarded.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/memberprice.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <li>In the receipt printed</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/receiptDiscount.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <li>we will show the member price and regular price together, and the regular price will be showing as discarded.</li>
                <li>If the regular price and the member price are the same, there is nothing changed in all places.</li>
            </ul>
        </div>)
    },
    {
        title: "PO template related change and campaign delete feature",
        dateAdded: "06/13/2022",
        contents: (<div>
            <ul>
                <li>For PO cannabis template:</li>
                <li>a new field in cannabis PO import template which name is DFE, here are the new columns:</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/cannabistemplate.png" className="imgNewFeatureComponent mt-1" />
                <li>When people create new products, DFE is mandatory field and people have to fill it up.</li>
                <br />
                <li>For PO accessory template:</li>
                <li>Changed the "totalCostPrice" to "UnitCostPrice":</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/accessroiesTemplate.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <li>Added a button for people to delete campaigns directly in campaign list page, they can delete campaigns by one button click.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/campignView.png" className="imgNewFeatureComponent mt-1" />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Add address for delivery orders to online order prepare page, add filter in online order list page",
        dateAdded: "06/09/2022",
        contents: (<div>
            <ul>
                <li>If the online order is for delivery, we will show the delivery address in the online order preparing page:</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/prepareOrder.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <li>These is a new filter added to the online order list page to check the type for different online orders:</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/filter.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <li>Here are the options</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/optionsOrder.png" className="imgNewFeatureComponent mt-1" />
                <br />
            </ul>
        </div>)
    },
    {
        title: "Add latest base cost in product view and detail page",
        dateAdded: "06/03/2022",
        contents: (<div>
            <ul>
                <li>base cost for product in product view and edit page.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/generalinfo.png" className="imgNewFeatureComponent mt-1" />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/productinfo.png" className="imgNewFeatureComponent mt-1" />
            </ul>
        </div>)
    },
    {
        title: "Setting for only managers can apply discounts",
        dateAdded: "06/02/2022",
        contents: (<div>
            <ul>
                <li>A new setting in our settings table called "DiscountNeedManagerApproval", default is false, if this setting is turned to be true, then for manual discounts in order/product level, by both credentials and pin code, a manager level's credential is needed to apply that discount. It will show "not have enough privilege to approve this discount."</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/discountmanagers.png" className="imgNewFeatureComponent mt-1" />
                <li>The customized discount are not affected, sales person can still apply customized discounts by themselves if the settings is turned to be true.</li>
            </ul>
        </div>)
    },
    {
        title: "Add sync from catalog functionality for UPC update",
        dateAdded: "05/30/2022",
        contents: (<div>
            <ul>
                <li>Instead of a manual update, right now we have a new button in product edit page that people can click then we will search the UPC for the product automatically in the catalog.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/syncupc.png" className="imgNewFeatureComponent mt-1" />
                <li>the button is called "SYNC UPC FROM CATALOG"</li>
                <li>if we successfully find the upc for this sku in the catalog and the upc is updated to a different number, we will show update success.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/upcupdated.png" className="imgNewFeatureComponent mt-1" />
                <li>If we find the upc for this sku is already the same as what it is in the system, we will show:</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/upcInCatalog.png" className="imgNewFeatureComponent mt-1" />
                <li>If we can't find the upc for this sku, we will show:</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/upcInCatalog.png" className="imgNewFeatureComponent mt-1" />
            </ul>
        </div>)
    },
    {
        title: "Web menu cart auto clear after certain time/switch branches",
        dateAdded: "05/27/2022",
        contents: (<div>
            <ul>
                <li>For express checkout, we have the ability to auto clear cart if there is no movement after a certain time</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/webmenuItem.png" className="imgNewFeatureComponent mt-1" />
                <li>When branches get switched the shopping cart will be reset</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/npUPC.png" className="imgNewFeatureComponent mt-1" />
            </ul>
        </div>)
    },
    {
        title: "Web Menu List View Option",
        dateAdded: "05/26/2022",
        contents: (<div>
            <ul>
                <li>Now customers can select how show their items. By default, the products will be displayed in card view version</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/cardview1.png" className="imgNewFeatureComponent mt-1" />
                <li>By clicking the button where it says view, a dropdown will show up and you can select the list view</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/listview1.png" className="imgNewFeatureComponent mt-1" />
                <li>In case the customer access the web menu using a mobile device the list view will be displayed by default.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/listview2.png" className="imgNewFeatureComponent mt-1" />
            </ul>
        </div>)
    },
    {
        title: "Remove THC/CBD value",
        dateAdded: "05/19/2022",
        contents: (<div>
            <p>Now customers will be able to see the THC and CBD values only if they are logged in <strong>NOTE: THIS FEATURE ONLY APPLY FOR ALBERTA CUSTOMERS</strong></p>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/removeTHC1.png" className="imgNewFeatureComponent mt-1" />
            <br />
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/removeTHC2.png" className="imgNewFeatureComponent mt-1" />
            <br />
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/removeTHC3.png" className="imgNewFeatureComponent mt-1" />
        </div>)
    },
    {
        title: "POS Quantity amount and scroll",
        dateAdded: "05/18/2022",
        contents: (<div>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/units.png" className="imgNewFeatureComponent mt-1" />
            <br />
            <br />
            <br />
            <p>Previously, we had to pass throw all pages to find any product and go back to the right page to look at it. Now, we add a button which load more products into the current list. With the scroll, we can see all products from top to bottom.</p>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/showMore.png" className="imgNewFeatureComponent mt-1" />
        </div>)
    },
    {
        title: "Add sounds notification when new queued order coming to the system",
        dateAdded: "05/13/2022",
        contents: (<div>
            <p>Now whenever there is a new queued order coming to the system, there will be a "beep' sound playing in the POS page directly.</p>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/soundNotification.png" className="imgNewFeatureComponent mt-1" />
            <p>If you have any new queued orders and you refresh the page, it will beep again as well.</p>
        </div>)
    },
    {
        title: "Enter for searching for products",
        dateAdded: "05/12/2022",
        contents: (<div>
            <p>Now you can search your products by pressing enter key to search. this feature work in some of our pages listed below:</p>
            <ul>
                <li>Products</li>
                <li>Categories</li>
                <li>Purchase Orders</li>
                <li>Warehouse</li>
                <li>Inventory Adjust</li>
                <li>Member</li>
                <li>Cash Register</li>
                <li>Shifts</li>
                <li>Orders</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/entersearch.png" className="imgNewFeatureComponent mt-1" />
            </ul>
        </div>)
    },
    {
        title: "Weedmaps Integration - Menu Listing",
        dateAdded: "05/05/2022",
        contents: (<div>
            <p>The first step for Weedmaps integration is done and ready to be implemented. In this email, I will explain this feature, and how our support and dev team can implement it.</p>
            <ol>
                <li>The first step is making sure our customer has already an account with Weedmaps. They should have an <strong>account</strong> and at list <strong>1 listing (menu)</strong>, Weedmaps work with 2 types of listing: <strong>Dispensaries</strong> and <strong>Deliveries.</strong></li>
                <li>Setup POS. To do this you will have to save 3 values on the database:</li>
                <ul>
                    <li>Weedmaps <strong>UID</strong></li>
                    <li>Weedmaps <strong>Secret</strong></li>
                    <li>Weedmaps <strong>VMID</strong> (listing menu number)</li>
                </ul>
                <p>Also, you will have to set the value WeedmapsEnable into true.</p>
                <li>You can sync all products to Weedmaps with the button with the same name. This is located under Inventory adjust. This button is enabled when you set the value WeedmapsEnable in the database.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/weedmapsIntegration.png" className="imgNewFeatureComponent mt-1" />
            </ol>
        </div>)
    },
    {
        title: "Remove price matrix from campaign",
        dateAdded: "05/05/2022",
        contents: (<div>
            <ul>
                <li>Removed price matrix from Add Campaign. Previously, we have this value for all customers and all types of stores, now this value will show up when the store is selling for Medical purposes. For those who sell for recreational purposes, the price matrix selection input will be hidden.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/addToCampaign.png" className="imgNewFeatureComponent mt-1" />
                <li><em>Recreational</em></li>
            </ul>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/addToCampaignMedical.png" className="imgNewFeatureComponent mt-1" />
            <ul>
                <li><em>Medical</em></li>
            </ul>
        </div>)
    },
    {
        title: "Images on Marketing email",
        dateAdded: "05/05/2022",
        contents: (<div>
            <ul>
                <li>Now you can add images in your marketing email. To add the image you will find a button to upload the image. Once the image is there you can have the ability to choose where the image will be by selecting the logo position settings and the size of the picture. Also, you will be able to preview the result.
                </li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/imageOnEmail.png" className="imgNewFeatureComponent mt-1" />
            </ul>
        </div>)
    },
    {
        title: "Add export feature in warehouse list page",
        dateAdded: "04/29/2022",
        contents: (<div>
            <ul>
                <li>In warehouse list page, there will be a new button called "Export to CSV".</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/exportcsv.png" className="imgNewFeatureComponent mt-1" />
                <li className="mt-1">When people click on this button, a dialog will show up to let them select whether they want to export the warehouse with inventory number or should the export also export products with 0 quantity:</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/csvoption.png" className="imgNewFeatureComponent mt-1" />
                <li className="mt-1">After they choose the options and click export, the existing warehouse will be exported to a csv file.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/csvselected.png" className="imgNewFeatureComponent mt-1" />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/csvresult.png" className="imgNewFeatureComponent mt-1" />
                <li className="mt-1">If they choose not to export sold out products, then all products that are not available in our system won't be exported.</li>
                <li>If they choose not to export inventory number, all products will be 0 quantity in the file exported.</li>
                <li>They can also select a category or any other filter in the warehouse list page, then click export, then the export will only export the inventory with the filter selected.</li>
            </ul>
        </div>)
    },
    {
        title: "Web menu & express checkout UI tweaks",
        dateAdded: "04/26/2022",
        contents: (<div>
            <ol>
                <li>Remove the location selection button for express checkout</li>
                <li>
                    Express checkout won't show store rules
                </li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/expresscheckoutMenu.png" className="imgNewFeatureComponent mt-1" style={{ border: '1px solid' }} />
                <li className="mt-1">
                    Change the text "same day delivery" to "delivery" since some customers don't support same day delivery.
                </li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/DeliverOptions.png" className="imgNewFeatureComponent mt-1" style={{ border: '1px solid' }} />
            </ol>
        </div>)
    },
    {
        title: "Add printing label to PO receive page",
        dateAdded: "04/25/2022",
        contents: (<div>
            <ul>
                <li className="mt-1">
                    An extra button in POS page which allow people to run the init function directly by themselves, here is how it works:
                </li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/receivingPO.png" className="imgNewFeatureComponent mt-1" />
            </ul>
            <ul>
                <li className="mt-1">
                    Right now for accessories, there will be a "PRINT LABEL" button in the scan bar code page, they can click the button to print the label directly:
                </li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/printLabel.png" className="imgNewFeatureComponent mt-1" />
            </ul>
        </div>)
    },
    {
        title: "Add ability of init moneris pinpad directly in UI",
        dateAdded: "04/25/2022",
        contents: (<div>
            <ul>
                <li className="mt-1">
                    An extra button in POS page which allow people to run the init function directly by themselves, here is how it works:
                </li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/init moneris.png" className="mt-1" style={{ height: 'auto', width: '350px' }} />
            </ul>
            <ul>
                <li className="mt-1">
                    If you are using Moneris, there will be an extra button called "INIT MONERIS PINPAD' when you click the "OPTIONS" button, after you click the extra button, the system will start to init automatically, and it will show either success or fail after the init is done.
                </li>
            </ul>
        </div>)
    },
    {
        title: "Change Password on Web Menu",
        dateAdded: "04/06/2022",
        contents: (<div>
            <ul>
                <li className="mt-1">
                    Now Customers can change their password. Under My accounts &#8594; account details, there is a new button called "edit my password
                </li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/customerInfo.png" className="imgNewFeatureComponent mt-1" style={{ border: '1px solid' }} />
            </ul>
            <ul>
                <li className="mt-1">Once you click this button, a new dialog will pop up:</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/customerInfopopup.png" className="imgNewFeatureComponent mt-1" style={{ border: '1px solid' }} />
            </ul>
            <ul>
                <li className="mt-1">You can update your password by inputting old and new password and clicking the "update password" button, once things are validated, your password will be updated.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/passwordChanged.png" className="imgNewFeatureComponent mt-1" style={{ border: '1px solid' }} />
            </ul>
        </div>)
    },
    {
        title: "POS Tooltips",
        dateAdded: "04/05/2022",
        contents: (<div>
            <h4>POS Not Configured</h4>
            <ol>
                <li>Check if the POS terminal has internet access</li>
                <li>If using Chrome, check the Google Chrome setting:
                    <ul>
                        <li className="mt-1">
                            Enter chrome://flags on the search bar
                        </li>
                        <img src="https://techposdev.blob.core.windows.net/newfeatureimages/flag.png" alt="import dialog" className="imgNewFeatureComponent" />
                        <li className="mt-1">
                            Search for Anonymize local IPs exposed by WebRTC and set it to Disabled
                        </li>
                        <img src="https://techposdev.blob.core.windows.net/newfeatureimages/anonimize.png" alt="import dialog" className="imgNewFeatureComponent" />
                    </ul>
                </li>
                <li className="mt-1">Update the IP Address:</li>
                <ul>
                    <li>On the TechPOS Core, go to Menu &#8250; Preference &#8250; Device. </li>
                    <li>Click on the pencil button for the terminal you are working on</li>
                    <li>Click on Update IP Address and Save</li>
                    <img src="https://techposdev.blob.core.windows.net/newfeatureimages/updateIP.png" alt="import dialog" className="imgNewFeatureComponent" />
                </ul>
            </ol>
            <h4>Cash In PopUp</h4>
            <ul>
                <li>Now, you can close the open register just pressing the button to close the open register</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/cashInfix.png" alt="import dialog" className="imgNewFeatureComponent" />
            </ul>
            <h4>Hardware Error Popup/Printer not Printing</h4>
            <ul>
                <li>To troubleshoot, please click on the button below. If the problem persists, please contact the support at <strong>833.722.3663</strong></li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/cashregisterissue.png" alt="import dialog" className="imgNewFeatureComponent mt-1" />
            </ul>
        </div>)
    },
    {
        title: "Add a search button for adding products in PO save page and some reports",
        dateAdded: "04/04/2022",
        contents: (<div>
            <ul>
                <li>Now there will be a "search product" button beside all auto complete select input</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/productDetail.png" alt="import dialog" className="imgNewFeatureComponent" />
            </ul>
            <ul>
                <li>After Budtenders input the product that they want to add to the PO, they have to click "search product" first, then our system will do a search and  the auto complete form will load all the products returned from the search result and show up</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/productSearch.png" alt="import dialog" className="imgPOAddProduct" />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/productResult.png" alt="import dialog" className="imgPOAddProduct" />
            </ul>
            <ul>
                <li>This search button is in some of the reports that is for specific product as well</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/orderDetail.png" alt="import dialog" className="imgNewFeatureComponent" />
            </ul>
        </div>)
    },
    {
        title: "Add Shipping/Curbside Pickup/ Drive Through Pickup Option To System.",
        dateAdded: "03/28/2022",
        contents: (<div>
            <ul>
                <li>The option for curbside pickup/ drive through pick up, which is under in store pick up options, this list will show when people choose "in store pick up"</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/pickupOption.png" alt="import dialog" className="imgNewFeatureComponent" />
            </ul>
            <ul>
                <li>The option for shipping, which is separate from the deliver to home option.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/DeliverOptions.png" alt="import dialog" className="imgNewFeatureComponent" />
            </ul>
            <ul>
                <li>When  people select shipping, the shipping fee calculation will be a flat fee, which is different from the delivery fee as well.</li>
                <li>After people select either shipping/curbside pickup/ drive through pickup and checkout, the method they select will show up in the receipt that is printed from the print server. </li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/receipt.png" alt="import dialog" className="imgCampaignFeature" />
                <li>You can see "curbside pickup' in the receipt above.</li>
            </ul>
        </div>)
    },
    {
        title: "Add scanning ability in warehouse page and inventory adjust page",
        dateAdded: "03/22/2022",
        contents: (<div>
            <ul>
                <li>Budtenders has the ability to scan the product in these two pages and the product will appear in the page directly.</li>
                <li>The page looks exactly same as before.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/scanItem.png" alt="import dialog" className="imgNewFeatureComponent" />
            </ul>
            <ul>
                <li>but after scan the item/product, only the scanned product will be showing in the page.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/scannedItem.png" alt="import dialog" className="imgNewFeatureComponent" />
            </ul>
            <ul>
                <li>If there is nothing found from the scan, there will be a dialog notify customers that no product is found.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/ProductNotFound.png" alt="import dialog" className="imgNewFeatureComponent" />
            </ul>
        </div>)
    },
    {
        title: "Adding Member Edit Feature In POS Page",
        dateAdded: "03/11/2022",
        contents: (<div>
            <ul>
                <li>We can edit member information directly in POS page once we get the member when searching.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/memberSearch.png" alt="import dialog" className="imgNewFeatureComponent" />
                <br />
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/viewMember.png" alt="import dialog" className="imgNewFeatureComponent" />
            </ul>
            <ul>
                <li>Now for users that are having online access if we detect the user already has the access, we will show "online user generated" instead of "generate online user"</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/onlineGenerator.png" alt="import dialog" className="imgNewFeatureComponent" />
            </ul>
        </div>)
    },
    {
        title: "Add Refund Reason And Refund Notes In Product Sales Report",
        dateAdded: "03/09/2022",
        contents: (<div>
            <ul>
                <li>In product refund dialog, there is an extra field called "Notes" which is an optional field.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/refundNote.png" alt="import dialog" className="imgNewFeatureComponent" />
            </ul>
            <ul>
                <li>The reason and notes that are filled up in the refund dialog will show in the product sales report.</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/refundDialog.png" alt="import dialog" className="imgNewFeatureComponent" />
            </ul>
        </div>)
    },
    {
        title: "Age checker integration for AB regulation",
        dateAdded: "03/08/2022",
        contents: (<div>
            <p>If customer doesn't login, they can't see any image in the web menu, including the homePage, product list page, product detail page and cart page. When they click "proceed to checkout" button, the Age checker pop up will show, they have to finish the age checker validation in order to process with the payment.</p>
            <ul>
                <li>Home Page</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/HomepageAb.png" alt="import dialog" className="imgNewFeatureComponent" />
            </ul>
            <ul>
                <li>Product List Page:</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/productPageAb.png" alt="import dialog" className="imgNewFeatureComponent" />
            </ul>
            <ul>
                <li>Product Detail Page:</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/productDetailPageAb.png" alt="import dialog" className="imgNewFeatureComponent" />
            </ul>
            <ul>
                <li>Cart Page:</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/cartAb.png" alt="import dialog" className="imgNewFeatureComponent" />
            </ul>
            <ul>
                <li>Checkout Page:</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/checkoutAb.png" alt="import dialog" className="imgNewFeatureComponent" />
            </ul>
        </div>)
    },
    {
        title: "Price Include Tax",
        dateAdded: "02/28/2022",
        contents: (<div>
            <p>Now, you can show you products with the tax included or not.</p>
            <ul>
                <li>No tax included</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/sensistarNoTax.png" alt="import dialog" className="imgCampaignFeature" />
            </ul>
            <ul>
                <li>All tax included</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/sensistarWithTax.png" alt="import dialog" className="imgCampaignFeature" />
                <li>
                    When the products are added to the order, nothing will be changed, Budtenders will still see the $5 as subtotal and $0.6 as tax.
                </li>
            </ul>
            <ul>
                <li>
                    Also it applies the changes to Webmenu
                </li>
            </ul>
            <ul>
                <li>No tax included</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/TantalusNoTax.png" alt="import dialog" className="imgCampaignFeature" />
            </ul>
            <ul>
                <li>All tax included</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/TantalusWithTax.png" alt="import dialog" className="imgCampaignFeature" />
                <li>
                    When the products are added to the order, nothing will be changed, Budtenders will still see the $5 as subtotal and $0.6 as tax.
                </li>
            </ul>
            <ul>
                <li>
                    In product list/edit page and in all other pages in POS, no change has been made, which means all the prices are still without taxes.
                </li>
            </ul>
        </div>)
    },
    {
        title: "Add Webmenu Enabled & Digital Signage Enabled Filter to Inventory Adjust Page",
        dateAdded: "02/18/2022",
        contents: (<div>
            <ul>
                <li>
                    You can filter products by these two new filters for products, the filters will contain 3 options: All, Yes and No.
                </li>
            </ul>
            <ul>
                <li>Yes means it is enabled</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/digitalsignageyes.png" alt="import dialog" className="imgNewFeatureComponent" />
            </ul>
            <ul>
                <li>All means enable and not enable</li>
                <img src="https://techposdev.blob.core.windows.net/newfeatureimages/digitalsignageall.png" alt="import dialog" className="imgNewFeatureComponent" />
            </ul>
        </div>)
    },
    {
        title: "Campaign for Only Members",
        dateAdded: "02/17/2022",
        contents: (<div>
            <ul>
                <li>
                    There is improvements to our system and now you have a new feature that can make campaign only valid for members.
                </li>
                <li>
                    There is a button in campaign edit page:
                </li>
            </ul>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/campaign.png" alt="campaing button" className="imgNewFeatureComponent" />
            <li>If the "apply for members Only" toggle is turned to be "No", then everything will be the same. The campaign will be applied to all customers, in both POS and web menu.</li>
            <li>If the "apply for members Only" toggle is turned to be "Yes", then:</li>
            <ol>
                <li>In POS, after the order is linked to an existing member, the staff will be able to see the price after campaign,  otherwise the campaign won't apply for those products.</li>
                <li>In Webmenu, after customers login, they will be able to see the price after the campaign, otherwise the campaign won't apply for those products.</li>
            </ol>
            <p>For example: this product is 6.25 and there is an campaign with 25% off that only apply for members, before the order is linked to a member, the price won't change.</p>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/productnoCampaign.png" alt="campaing button" className="imgCampaignFeature" />
            <p>After we link a member to the order, the price we will see in POS will be: </p>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/productCampaign.png" alt="campaing button" className="imgCampaignFeature" />
            <p>This changes is all applied to web menu, customers will be able to see the discounted price after they login.</p>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/nouserlogged.png" alt="campaing button" className="imgCampaignFeature" />
            <p>The customer after the login may see the discount applied to that campaign: </p>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/userlogged.png" alt="campaing button" className="imgCampaignFeature" />
        </div>)
    },
    {
        title: "Promo Code Discount Feature",
        dateAdded: "02/10/2022",
        contents: (<div>
            <ul>
                <li>
                    You can create promotion code in customized discount section, you need to define what the promotion code and the minimum order amount for that promotion code can be used.
                </li>
            </ul>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/discountfeature.png" alt="discount feature" className="imgNewFeatureComponent" />
            <ul>
                <li>
                    After the promo code is created, when people checkout in the webmenu, there will be a section called "add promo code" under "Tax"
                </li>
            </ul>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/summary.png" alt="summary order" className="imgNewFeatureComponent" />
            <ul>
                <li>
                    Customers can apply the promo code they got on their hands.
                </li>
            </ul>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/applycode.png" alt="apply discount dialog" className="imgNewFeatureComponent" />
            <ul>
                <li>
                    It can be either applied or declined after people click "apply", if they click remove, it will remove the existing promo code.
                </li>
            </ul>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/applyorremove.png" alt="apply or remove discount" className="imgNewFeatureComponent" />
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/error.png" alt="error discount" className="imgNewFeatureComponent" />
            <ul>
                <li>
                    After checkout, everything will be the same afterwards, the store needs to prepare the order and the discount will be automatically applied for the POS order.
                </li>
            </ul>
            <h2><strong>Note:</strong></h2>
            <ol>
                <li>If there is a campaign applied for that product, the promo code will overwrite the campaign.</li>
                <li>if the promo discount is amount instead of percentage and the order subtotal &lt discount amount, that promo code can't be applied.</li>
            </ol>
        </div>)
    },
    {
        title: "Change Value in a Bigger Font Size",
        dateAdded: "02/09/2022",
        contents: (<div>
            <ul>
                <li>
                    After requests from some customers we implemented The Change value in a bigger font size
                </li>
            </ul>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/changefontSize.png" alt="POS change font size" className="imgNewFeatureComponent" />
        </div>)
    },
    {
        title: "Error Messages Showing for PO Import",
        dateAdded: "01/25/2022",
        contents: (<div>
            <ul>
                <li>
                    Improved error messages when catalog is imported.
                </li>
                <li>
                    When the accessories template is imported, if a problem is detected in the file format, this message will appear on the screen
                </li>
            </ul>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/wrongformat.png" alt="import fail" className="imgNewFeatureComponent mb-1" />
            <ul>
                <li>In case you are importing the government PO and there is no SKU. A button to import on the same page of the message, you can click the button to import the products from the catalog, instead of going to the product list page and click to import.</li>
            </ul>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/skufail.png" alt="Sku Fail Dialog" className="imgNewFeatureComponent" />
            <hr />
        </div>)
    },
    {
        title: "Inventory Adjust Page",
        dateAdded: "01/23/2022",
        contents: (<div>
            <ul>
                <li>
                    There is an branch filter for stores to switch branches easily to check the inventory for different branches without the need to switching the whole branch.
                </li>
                <li>
                    Stores can see the branch name in the title part of the page to help them know which inventory they are checking.
                </li>
                <li>
                    There is an checkbox called "Show Advanced Options', default is checked, if someone uncheck it, only product name, stock and selling price will show in  the page.
                </li>
            </ul>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/inventorypagesettings.png" alt="inventory settings on" className="imgNewFeatureComponent mb-1 mt-1" />
            <ul className="mt-1">
                <li>
                    Change the column name from "estimated quantity" to "In stock', change "sale price" to "selling price"
                </li>
                <li>
                    Make the product name bold.
                </li>
                <li>
                    We will show 10 products instead of 15 in one page for inventory adjustments.
                </li>
            </ul>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/inventorypagwithoutesettings.png" alt="inventory settings off" className="imgNewFeatureComponent mb-1" />
        </div>)
    },
    {
        title: "Auto Sync Feature in Multiple Browsers Preventions",
        dateAdded: "01/18/2022",
        contents: (<div>
            <ul>
                <li>
                    To avoid that the catalog is imported numerous times in different tabs and consequently causing problems to the federal report. The system will check if there is any tab importing the catalog and if so, a message will appear on the screen.
                </li>
            </ul>
            <img src="https://techposdev.blob.core.windows.net/newfeatureimages/autosyncprevention.png" alt="import dialog" className="imgNewFeatureComponent" />
        </div>)
    }
]
